<template>
	<svg class="mapaSV"
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:xlink="http://www.w3.org/1999/xlink"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   width="1022.4457pt"
   height="561.15503pt"
   viewBox="0 0 1022.4457 561.15503"
   version="1.2"
   id="svg6473"
   sodipodi:docname="Mapa-SV.svg"
   inkscape:version="0.92.5 (2060ec1f9f, 2020-04-08)">
  
  <defs
     id="defs5866">
    <g
       id="g5864">
      <symbol
         overflow="visible"
         id="glyph0-0"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 1.078125,0 H 14.71875 V -18.828125 H 1.078125 Z m 2.15625,-1.890625 v -15.0625 H 12.5625 v 15.0625 z m 0,0"
           id="path5660"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph0-1"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 17.140625,0 h 2.09375 L 10.625,-18.828125 H 8.65625 L 0.046875,0 H 2.125 L 4.390625,-5.03125 H 14.875 Z m -12.03125,-6.640625 4.515625,-10.125 4.53125,10.125 z m 0,0"
           id="path5663"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph0-2"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 6.734375,0 H 8.71875 v -17.109375 h 6.625 v -1.71875 H 0.109375 v 1.71875 h 6.625 z m 0,0"
           id="path5666"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph0-3"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 18.109375,0 13.5,-6.453125 c 2.75,-0.890625 4.3125,-2.96875 4.3125,-5.921875 0,-4.03125 -2.90625,-6.453125 -7.703125,-6.453125 H 3.0625 V 0 h 2 v -5.96875 h 5.046875 c 0.546875,0 1.03125,-0.03125 1.515625,-0.078125 L 15.921875,0 Z M 10.0625,-7.671875 h -5 v -9.4375 h 5 c 3.765625,0 5.765625,1.71875 5.765625,4.734375 0,2.953125 -2,4.703125 -5.765625,4.703125 z m 0,0"
           id="path5669"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph0-4"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 14.15625,-23.703125 h -2.5625 L 7.90625,-20.375 H 9.796875 Z M 17.140625,0 h 2.09375 L 10.625,-18.828125 H 8.65625 L 0.046875,0 H 2.125 L 4.390625,-5.03125 H 14.875 Z m -12.03125,-6.640625 4.515625,-10.125 4.53125,10.125 z m 0,0"
           id="path5672"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph0-5"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 8.265625,0.15625 c 4.8125,0 7.015625,-2.359375 7.015625,-5.140625 0,-6.859375 -11.59375,-3.734375 -11.59375,-8.90625 0,-1.875 1.53125,-3.40625 4.96875,-3.40625 1.671875,0 3.5625,0.5 5.171875,1.5625 L 14.5,-17.328125 C 13,-18.375 10.796875,-19 8.65625,-19 c -4.78125,0 -6.9375,2.40625 -6.9375,5.171875 0,6.96875 11.59375,3.796875 11.59375,8.953125 0,1.859375 -1.53125,3.34375 -5.046875,3.34375 -2.484375,0 -4.875,-0.96875 -6.21875,-2.296875 l -0.78125,1.546875 c 1.390625,1.453125 4.171875,2.4375 7,2.4375 z m 0,0"
           id="path5675"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph1-0"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 1.21875,0 H 16.75 V -21.4375 H 1.21875 Z m 2.453125,-2.140625 v -17.15625 h 10.625 v 17.15625 z m 0,0"
           id="path5678"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph1-1"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 11.578125,-21.4375 H 3.21875 V 0 h 3.0625 v -6.5 h 5.296875 c 5.578125,0 8.9375,-2.8125 8.9375,-7.46875 0,-4.65625 -3.359375,-7.46875 -8.9375,-7.46875 z m -0.09375,12.28125 H 6.28125 v -9.609375 h 5.203125 c 3.921875,0 5.96875,1.734375 5.96875,4.796875 0,3.0625 -2.046875,4.8125 -5.96875,4.8125 z m 0,0"
           id="path5681"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph1-2"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 3.21875,0 H 17.890625 V -2.671875 H 6.28125 V -21.4375 h -3.0625 z m 0,0"
           id="path5684"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph1-3"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 19.234375,0 h 3.21875 l -9.75,-21.4375 H 9.671875 L -0.03125,0 H 3.125 L 5.484375,-5.359375 H 16.875 Z m -12.6875,-7.8125 4.625,-10.5 4.625,10.5 z m 0,0"
           id="path5687"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph1-4"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 7.46875,0 H 10.5 v -18.765625 h 7.359375 V -21.4375 H 0.125 v 2.671875 h 7.34375 z m 0,0"
           id="path5690"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph1-5"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 18.34375,-18.765625 V -21.4375 H 3.21875 V 0 h 3.0625 v -8.671875 h 10.75 v -2.625 h -10.75 v -7.46875 z m 0,0"
           id="path5693"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph1-6"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 12.890625,0.25 C 19.421875,0.25 24.25,-4.40625 24.25,-10.71875 24.25,-17.03125 19.421875,-21.6875 12.890625,-21.6875 6.3125,-21.6875 1.46875,-17 1.46875,-10.71875 1.46875,-4.4375 6.3125,0.25 12.890625,0.25 Z m 0,-2.734375 c -4.8125,0 -8.359375,-3.484375 -8.359375,-8.234375 0,-4.75 3.546875,-8.234375 8.359375,-8.234375 4.75,0 8.296875,3.484375 8.296875,8.234375 0,4.75 -3.546875,8.234375 -8.296875,8.234375 z m 0,0"
           id="path5696"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph1-7"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 20.890625,0 -5.09375,-7.203125 c 3,-1.0625 4.71875,-3.453125 4.71875,-6.765625 0,-4.65625 -3.359375,-7.46875 -8.9375,-7.46875 H 3.21875 V 0 h 3.0625 v -6.515625 h 5.296875 c 0.453125,0 0.921875,-0.03125 1.34375,-0.0625 L 17.546875,0 Z m -9.40625,-9.125 H 6.28125 v -9.640625 h 5.203125 c 3.921875,0 5.96875,1.734375 5.96875,4.796875 0,3.0625 -2.046875,4.84375 -5.96875,4.84375 z m 0,0"
           id="path5699"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph1-8"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 26.03125,0 26,-21.4375 h -2.515625 l -8.8125,15.0625 -8.9375,-15.0625 H 3.21875 V 0 h 2.9375 v -15.53125 l 7.75,12.921875 H 15.3125 L 23.0625,-15.625 23.09375,0 Z m 0,0"
           id="path5702"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph1-9"
         style="overflow:visible">
        <path
           style="stroke:none"
           d=""
           id="path5705"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph1-10"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 12.796875,0.25 c 3.34375,0 6.21875,-1.171875 8.1875,-3.375 l -2,-1.921875 c -1.65625,1.734375 -3.671875,2.5625 -6.03125,2.5625 -4.84375,0 -8.421875,-3.484375 -8.421875,-8.234375 0,-4.75 3.578125,-8.234375 8.421875,-8.234375 2.359375,0 4.375,0.796875 6.03125,2.53125 l 2,-1.921875 c -1.96875,-2.203125 -4.84375,-3.34375 -8.15625,-3.34375 -6.515625,0 -11.359375,4.625 -11.359375,10.96875 C 1.46875,-4.375 6.3125,0.25 12.796875,0.25 Z m 0,0"
           id="path5708"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph1-11"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 19.9375,-21.4375 H 16.90625 L 10.015625,-10.140625 3.15625,-21.4375 H -0.125 L 8.390625,-7.46875 V 0 h 3.03125 v -7.40625 z m 0,0"
           id="path5711"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph1-12"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 18.59375,-21.4375 V -5.453125 L 5.734375,-21.4375 H 3.21875 V 0 h 3.0625 V -15.984375 L 19.140625,0 h 2.515625 v -21.4375 z m 0,0"
           id="path5714"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph2-0"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 1.421875,0 H 19.53125 V -25 H 1.421875 Z M 4.28125,-2.5 v -20 h 12.390625 v 20 z m 0,0"
           id="path5717"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph2-1"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 8.71875,-4.640625 v -5.78125 H 20.3125 v -4.5 H 8.71875 v -5.421875 h 13.125 V -25 H 2.96875 V 0 H 22.3125 v -4.640625 z m 0,0"
           id="path5720"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph2-2"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 7.5625,0.421875 c 5.890625,0 9,-3.03125 9,-9.203125 V -25 H 2.03125 v 4.65625 h 8.78125 v 11.875 c 0,2.75 -1.203125,4.15625 -3.53125,4.15625 C 5.5,-4.3125 4,-5.25 2.640625,-7.0625 l -3.21875,3.84375 C 1.25,-0.859375 4.21875,0.421875 7.5625,0.421875 Z m 0,0"
           id="path5723"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph2-3"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 31.140625,0 31.0625,-25 h -4.75 L 17.109375,-9.46875 7.75,-25 H 2.96875 V 0 h 5.421875 v -14.671875 l 7.3125,12.03125 H 18.3125 L 25.671875,-15 25.703125,0 Z m 0,0"
           id="path5726"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph2-4"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 13.78125,-25 H 2.96875 V 0 H 8.75 v -6.890625 h 5.03125 c 6.671875,0 10.859375,-3.46875 10.859375,-9.03125 C 24.640625,-21.53125 20.453125,-25 13.78125,-25 Z m -0.328125,13.390625 H 8.75 v -8.671875 h 4.703125 c 3.546875,0 5.328125,1.609375 5.328125,4.359375 0,2.71875 -1.78125,4.3125 -5.328125,4.3125 z m 0,0"
           id="path5729"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph2-5"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 2.96875,0 h 18.3125 V -4.71875 H 8.75 V -25 H 2.96875 Z m 0,0"
           id="path5732"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph2-6"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 15.0625,0.421875 c 7.859375,0 13.671875,-5.453125 13.671875,-12.921875 0,-7.453125 -5.8125,-12.921875 -13.671875,-12.921875 -7.890625,0 -13.671875,5.5 -13.671875,12.921875 0,7.4375 5.78125,12.921875 13.671875,12.921875 z m 0,-4.921875 c -4.453125,0 -7.8125,-3.25 -7.8125,-8 0,-4.75 3.359375,-8 7.8125,-8 4.46875,0 7.828125,3.25 7.828125,8 0,4.75 -3.359375,8 -7.828125,8 z m 0,0"
           id="path5735"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph2-7"
         style="overflow:visible">
        <path
           style="stroke:none"
           d=""
           id="path5738"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph2-8"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 2.96875,0 H 14.3125 C 22.5,0 28.09375,-4.921875 28.09375,-12.5 28.09375,-20.0625 22.5,-25 14.3125,-25 H 2.96875 Z M 8.75,-4.75 v -15.5 h 5.28125 c 4.96875,0 8.21875,2.96875 8.21875,7.75 0,4.78125 -3.25,7.75 -8.21875,7.75 z m 0,0"
           id="path5741"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph2-9"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 21.25,-25 13.53125,-7.140625 5.921875,-25 h -6.25 L 10.46875,0 h 5.703125 l 10.8125,-25 z m 0,0"
           id="path5744"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph2-10"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 2.96875,0 H 8.75 V -25 H 2.96875 Z m 0,0"
           id="path5747"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph2-11"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 11.171875,0.421875 c 7.140625,0 10.609375,-3.5625 10.609375,-7.734375 0,-9.1875 -14.53125,-6 -14.53125,-10.609375 0,-1.578125 1.3125,-2.859375 4.75,-2.859375 2.203125,0 4.609375,0.640625 6.921875,1.96875 l 1.78125,-4.390625 c -2.3125,-1.46875 -5.53125,-2.21875 -8.671875,-2.21875 -7.109375,0 -10.53125,3.53125 -10.53125,7.78125 0,9.28125 14.53125,6.078125 14.53125,10.75 0,1.53125 -1.390625,2.671875 -4.828125,2.671875 -2.984375,0 -6.140625,-1.0625 -8.234375,-2.59375 L 1,-2.46875 C 3.21875,-0.75 7.21875,0.421875 11.171875,0.421875 Z m 0,0"
           id="path5750"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph2-12"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 8.140625,0 h 5.78125 v -20.28125 h 8 V -25 H 0.140625 v 4.71875 h 8 z m 0,0"
           id="path5753"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph2-13"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 21.640625,0 h 6.0625 L 16.53125,-25 H 10.8125 L -0.328125,0 h 5.9375 L 7.8125,-5.359375 h 11.609375 z m -11.96875,-9.75 3.96875,-9.5625 3.96875,9.5625 z m 0,0"
           id="path5756"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph2-14"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 14.921875,0.421875 c 4.359375,0 7.96875,-1.5625 10.3125,-4.453125 L 21.53125,-7.46875 C 19.84375,-5.5 17.75,-4.5 15.25,-4.5 c -4.6875,0 -8,-3.28125 -8,-8 0,-4.703125 3.3125,-8 8,-8 2.5,0 4.59375,1 6.28125,2.9375 L 25.234375,-21 c -2.34375,-2.84375 -5.953125,-4.421875 -10.28125,-4.421875 -7.78125,0 -13.5625,5.390625 -13.5625,12.921875 0,7.53125 5.78125,12.921875 13.53125,12.921875 z m 0,0"
           id="path5759"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph2-15"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 25.09375,0 19.5,-8.03125 c 3.25,-1.390625 5.140625,-4.140625 5.140625,-7.890625 C 24.640625,-21.53125 20.453125,-25 13.78125,-25 H 2.96875 V 0 H 8.75 v -6.96875 h 5.3125 L 18.890625,0 Z m -6.3125,-15.921875 c 0,2.71875 -1.78125,4.359375 -5.328125,4.359375 H 8.75 v -8.71875 h 4.703125 c 3.546875,0 5.328125,1.609375 5.328125,4.359375 z m 0,0"
           id="path5762"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph2-16"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 19.84375,-5.5625 C 18.390625,-4.78125 16.921875,-4.5 15.359375,-4.5 10.5625,-4.5 7.25,-7.8125 7.25,-12.5 c 0,-4.75 3.3125,-8 8.171875,-8 2.53125,0 4.640625,0.90625 6.46875,2.828125 l 3.703125,-3.421875 c -2.421875,-2.828125 -6.0625,-4.328125 -10.453125,-4.328125 -7.96875,0 -13.75,5.390625 -13.75,12.921875 0,7.53125 5.78125,12.921875 13.640625,12.921875 3.5625,0 7.359375,-1.09375 10.109375,-3.171875 V -12.890625 H 19.84375 Z m 0,0"
           id="path5765"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph2-17"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 20.171875,-25 V -9.8125 L 7.75,-25 H 2.96875 V 0 H 8.671875 V -15.171875 L 21.140625,0 h 4.75 v -25 z m 0,0"
           id="path5768"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-0"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 0.71875,0 h 9.125 v -12.59375 h -9.125 z m 1.4375,-1.265625 V -11.34375 h 6.25 v 10.078125 z m 0,0"
           id="path5771"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-1"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 11.125,0 h 2.453125 l -5.6875,-12.59375 h -2.3125 L -0.09375,0 H 2.328125 L 3.5625,-2.921875 H 9.859375 Z M 4.359375,-4.75 6.71875,-10.265625 9.09375,-4.75 Z m 0,0"
           id="path5774"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-2"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 6.9375,-9.71875 c -1.34375,0 -2.46875,0.4375 -3.21875,1.21875 v -4.859375 h -2.25 V 0 h 2.25 v -4.859375 c 0,-1.921875 1.09375,-2.90625 2.6875,-2.90625 1.4375,0 2.28125,0.828125 2.28125,2.546875 V 0 h 2.25 v -5.515625 c 0,-2.890625 -1.703125,-4.203125 -4,-4.203125 z m 0,0"
           id="path5777"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-3"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 8.53125,-9.609375 V -4.75 c 0,1.921875 -1.0625,2.890625 -2.625,2.890625 -1.421875,0 -2.25,-0.828125 -2.25,-2.5625 v -5.1875 h -2.25 V -4.125 c 0,2.90625 1.671875,4.25 4.140625,4.25 1.234375,0 2.375,-0.46875 3.09375,-1.34375 V 0 h 2.140625 v -9.609375 z m 0,0"
           id="path5780"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-4"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 5.140625,-9.71875 c -1.546875,0 -3.03125,0.390625 -4.0625,1.1875 L 1.96875,-6.890625 C 2.6875,-7.484375 3.796875,-7.84375 4.875,-7.84375 c 1.609375,0 2.390625,0.765625 2.390625,2.078125 v 0.15625 H 4.78125 c -2.90625,0 -3.984375,1.25 -3.984375,2.859375 0,1.671875 1.375,2.875 3.578125,2.875 1.4375,0 2.484375,-0.46875 3.015625,-1.296875 V 0 h 2.125 v -5.640625 c 0,-2.765625 -1.59375,-4.078125 -4.375,-4.078125 z M 4.84375,-1.515625 C 3.6875,-1.515625 3,-2.03125 3,-2.84375 3,-3.546875 3.421875,-4.125 4.953125,-4.125 h 2.3125 V -3 c -0.375,0.984375 -1.328125,1.484375 -2.421875,1.484375 z m 0,0"
           id="path5783"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-5"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 5.890625,0.125 c 1.875,0 3.359375,-0.8125 4.09375,-2.25 l -1.71875,-1 C 7.6875,-2.21875 6.828125,-1.796875 5.875,-1.796875 c -1.65625,0 -2.921875,-1.140625 -2.921875,-3.015625 0,-1.84375 1.265625,-3 2.921875,-3 0.953125,0 1.8125,0.421875 2.390625,1.328125 l 1.71875,-1 C 9.25,-8.953125 7.765625,-9.71875 5.890625,-9.71875 2.84375,-9.71875 0.6875,-7.6875 0.6875,-4.8125 c 0,2.890625 2.15625,4.9375 5.203125,4.9375 z m 0,0"
           id="path5786"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-6"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 6.796875,-9.71875 c -1.3125,0 -2.421875,0.453125 -3.171875,1.359375 v -1.25 H 1.46875 v 13.09375 h 2.25 v -4.65625 C 4.5,-0.28125 5.578125,0.125 6.796875,0.125 c 2.8125,0 4.890625,-1.9375 4.890625,-4.9375 0,-2.96875 -2.078125,-4.90625 -4.890625,-4.90625 z m -0.25,7.921875 C 4.9375,-1.796875 3.6875,-2.96875 3.6875,-4.8125 c 0,-1.828125 1.25,-3 2.859375,-3 1.625,0 2.84375,1.171875 2.84375,3 0,1.84375 -1.21875,3.015625 -2.84375,3.015625 z m 0,0"
           id="path5789"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-7"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 8.90625,-13.390625 H 6.265625 l -2.4375,2.46875 H 5.78125 Z M 5.140625,-9.71875 c -1.546875,0 -3.03125,0.390625 -4.0625,1.1875 L 1.96875,-6.890625 C 2.6875,-7.484375 3.796875,-7.84375 4.875,-7.84375 c 1.609375,0 2.390625,0.765625 2.390625,2.078125 v 0.15625 H 4.78125 c -2.90625,0 -3.984375,1.25 -3.984375,2.859375 0,1.671875 1.375,2.875 3.578125,2.875 1.4375,0 2.484375,-0.46875 3.015625,-1.296875 V 0 h 2.125 v -5.640625 c 0,-2.765625 -1.59375,-4.078125 -4.375,-4.078125 z M 4.84375,-1.515625 C 3.6875,-1.515625 3,-2.03125 3,-2.84375 3,-3.546875 3.421875,-4.125 4.953125,-4.125 h 2.3125 V -3 c -0.375,0.984375 -1.328125,1.484375 -2.421875,1.484375 z m 0,0"
           id="path5792"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-8"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 6.9375,-9.71875 C 5.53125,-9.71875 4.359375,-9.25 3.625,-8.375 V -9.609375 H 1.46875 V 0 h 2.25 v -4.859375 c 0,-1.921875 1.09375,-2.90625 2.6875,-2.90625 1.4375,0 2.28125,0.828125 2.28125,2.546875 V 0 h 2.25 v -5.515625 c 0,-2.890625 -1.703125,-4.203125 -4,-4.203125 z m 0,0"
           id="path5795"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-9"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 5.59375,0.1875 c 3.453125,0 5.09375,-1.734375 5.09375,-3.75 0,-4.625 -7.46875,-2.875 -7.46875,-5.5625 0,-0.953125 0.796875,-1.703125 2.734375,-1.703125 1.109375,0 2.34375,0.3125 3.484375,0.984375 l 0.734375,-1.8125 c -1.09375,-0.734375 -2.6875,-1.125 -4.203125,-1.125 -3.453125,0 -5.0625,1.734375 -5.0625,3.765625 0,4.671875 7.484375,2.890625 7.484375,5.609375 0,0.9375 -0.828125,1.640625 -2.796875,1.640625 -1.546875,0 -3.140625,-0.578125 -4.15625,-1.390625 L 0.625,-1.328125 C 1.671875,-0.4375 3.640625,0.1875 5.59375,0.1875 Z m 0,0"
           id="path5798"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-10"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 6.625,-2.125 c -0.34375,0.265625 -0.796875,0.390625 -1.265625,0.390625 -0.859375,0 -1.328125,-0.5 -1.328125,-1.4375 v -4.5625 h 2.578125 v -1.8125 H 4.03125 v -2.1875 h -2.25 v 2.1875 H 0.203125 v 1.8125 H 1.78125 v 4.625 c 0,2.125 1.203125,3.234375 3.3125,3.234375 0.8125,0 1.625,-0.21875 2.15625,-0.640625 z m 0,0"
           id="path5801"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-11"
         style="overflow:visible">
        <path
           style="stroke:none"
           d=""
           id="path5804"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-12"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 5.796875,0.125 c 2.984375,0 5.125,-2.046875 5.125,-4.9375 0,-2.875 -2.140625,-4.90625 -5.125,-4.90625 -2.953125,0 -5.109375,2.03125 -5.109375,4.90625 0,2.890625 2.15625,4.9375 5.109375,4.9375 z m 0,-1.921875 c -1.625,0 -2.84375,-1.171875 -2.84375,-3.015625 0,-1.828125 1.21875,-3 2.84375,-3 1.640625,0 2.859375,1.171875 2.859375,3 0,1.84375 -1.21875,3.015625 -2.859375,3.015625 z m 0,0"
           id="path5807"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-13"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 4.453125,0.125 c 2.6875,0 4.34375,-1.171875 4.34375,-2.96875 0,-3.765625 -5.9375,-2.03125 -5.9375,-3.984375 0,-0.625 0.65625,-1.078125 2.015625,-1.078125 0.921875,0 1.84375,0.1875 2.75,0.71875 L 8.5,-8.890625 C 7.625,-9.40625 6.171875,-9.71875 4.890625,-9.71875 c -2.59375,0 -4.21875,1.1875 -4.21875,3 0,3.84375 5.9375,2.109375 5.9375,3.953125 0,0.65625 -0.59375,1.0625 -2.015625,1.0625 -1.203125,0 -2.5,-0.40625 -3.359375,-0.953125 L 0.375,-0.953125 C 1.234375,-0.34375 2.84375,0.125 4.453125,0.125 Z m 0,0"
           id="path5810"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-14"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 10.515625,-4.75 c 0,-3.015625 -2.0625,-4.96875 -4.859375,-4.96875 -2.859375,0 -4.96875,2.046875 -4.96875,4.90625 0,2.875 2.078125,4.9375 5.3125,4.9375 1.65625,0 3,-0.53125 3.859375,-1.5625 L 8.65625,-2.828125 C 7.96875,-2.125 7.125,-1.78125 6.046875,-1.78125 4.375,-1.78125 3.203125,-2.6875 2.9375,-4.09375 h 7.53125 C 10.5,-4.296875 10.515625,-4.578125 10.515625,-4.75 Z M 5.65625,-7.921875 c 1.46875,0 2.53125,0.953125 2.71875,2.34375 H 2.921875 C 3.125,-6.984375 4.1875,-7.921875 5.65625,-7.921875 Z m 0,0"
           id="path5813"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-15"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 1.6875,0 H 10.625 V -1.984375 H 4.03125 V -12.59375 H 1.6875 Z m 0,0"
           id="path5816"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-16"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 2.609375,-11.203125 c 0.84375,0 1.4375,-0.609375 1.4375,-1.390625 0,-0.75 -0.609375,-1.296875 -1.4375,-1.296875 -0.828125,0 -1.4375,0.59375 -1.4375,1.34375 0,0.75 0.609375,1.34375 1.4375,1.34375 z M 1.46875,0 h 2.25 v -9.609375 h -2.25 z m 0,0"
           id="path5819"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-17"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 6.796875,-9.71875 C 5.578125,-9.71875 4.5,-9.3125 3.71875,-8.4375 v -4.921875 h -2.25 V 0 H 3.625 V -1.234375 C 4.375,-0.328125 5.484375,0.125 6.796875,0.125 c 2.8125,0 4.890625,-1.9375 4.890625,-4.9375 0,-2.984375 -2.078125,-4.90625 -4.890625,-4.90625 z m -0.25,7.921875 C 4.9375,-1.796875 3.6875,-2.96875 3.6875,-4.8125 c 0,-1.828125 1.25,-3 2.859375,-3 1.625,0 2.84375,1.171875 2.84375,3 0,1.84375 -1.21875,3.015625 -2.84375,3.015625 z m 0,0"
           id="path5822"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-18"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 3.625,-8.203125 v -1.40625 H 1.46875 V 0 h 2.25 v -4.65625 c 0,-1.96875 1.09375,-2.96875 2.796875,-2.96875 0.15625,0 0.328125,0.015625 0.515625,0.046875 V -9.71875 c -1.59375,0 -2.765625,0.5 -3.40625,1.515625 z m 0,0"
           id="path5825"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-19"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 8.640625,-13.359375 v 4.9375 C 7.890625,-9.3125 6.78125,-9.71875 5.546875,-9.71875 2.75,-9.71875 0.6875,-7.796875 0.6875,-4.8125 c 0,3 2.0625,4.9375 4.859375,4.9375 1.3125,0 2.421875,-0.453125 3.1875,-1.359375 V 0 h 2.15625 V -13.359375 Z M 5.8125,-1.796875 c -1.625,0 -2.859375,-1.171875 -2.859375,-3.015625 0,-1.828125 1.234375,-3 2.859375,-3 1.625,0 2.859375,1.171875 2.859375,3 0,1.84375 -1.234375,3.015625 -2.859375,3.015625 z m 0,0"
           id="path5828"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-20"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 7.53125,0.1875 c 2.0625,0 3.828125,-0.75 5,-2.109375 l -1.515625,-1.4375 c -0.921875,1 -2.046875,1.484375 -3.359375,1.484375 -2.609375,0 -4.5,-1.828125 -4.5,-4.421875 0,-2.59375 1.890625,-4.4375 4.5,-4.4375 1.3125,0 2.4375,0.5 3.359375,1.484375 l 1.515625,-1.421875 c -1.171875,-1.375 -2.9375,-2.109375 -4.984375,-2.109375 -3.875,0 -6.75,2.71875 -6.75,6.484375 0,3.765625 2.875,6.484375 6.734375,6.484375 z m 0,0"
           id="path5831"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-21"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 1.46875,0 h 2.25 v -13.359375 h -2.25 z m 0,0"
           id="path5834"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-22"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 8.875,-9.609375 v 1.28125 C 8.078125,-9.28125 6.890625,-9.71875 5.546875,-9.71875 c -2.75,0 -4.859375,1.828125 -4.859375,4.625 0,2.796875 2.109375,4.65625 4.859375,4.65625 1.296875,0 2.421875,-0.40625 3.21875,-1.265625 v 0.5 c 0,1.9375 -0.9375,2.90625 -3.0625,2.90625 C 4.375,1.703125 3,1.265625 2.15625,0.5625 l -1,1.6875 c 1.09375,0.90625 2.875,1.375 4.671875,1.375 3.375,0 5.1875,-1.59375 5.1875,-5.078125 v -8.15625 z M 5.890625,-2.34375 c -1.71875,0 -2.9375,-1.109375 -2.9375,-2.75 0,-1.625 1.21875,-2.71875 2.9375,-2.71875 1.6875,0 2.90625,1.09375 2.90625,2.71875 0,1.640625 -1.21875,2.75 -2.90625,2.75 z m 0,0"
           id="path5837"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-23"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 8.3125,-9.609375 -3.078125,7.125 L 2.25,-9.609375 H -0.09375 L 4.03125,0 h 2.328125 l 4.109375,-9.609375 z m 0,0"
           id="path5840"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-24"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 5.0625,-12.109375 c 0.640625,0 1.25,1.1875 2.4375,1.1875 1.15625,0 1.90625,-0.953125 1.953125,-2.359375 H 8.25 c -0.046875,0.640625 -0.390625,1.015625 -0.890625,1.015625 -0.640625,0 -1.25,-1.1875 -2.453125,-1.1875 -1.140625,0 -1.90625,0.9375 -1.9375,2.421875 h 1.203125 c 0.046875,-0.6875 0.375,-1.078125 0.890625,-1.078125 z m 1.875,2.390625 C 5.53125,-9.71875 4.359375,-9.25 3.625,-8.375 V -9.609375 H 1.46875 V 0 h 2.25 v -4.859375 c 0,-1.921875 1.09375,-2.90625 2.6875,-2.90625 1.4375,0 2.28125,0.828125 2.28125,2.546875 V 0 h 2.25 v -5.515625 c 0,-2.890625 -1.703125,-4.203125 -4,-4.203125 z m 0,0"
           id="path5843"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-25"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 6.875,-12.59375 H 1.6875 V 0 H 4.03125 V -3.640625 H 6.875 c 3.3125,0 5.359375,-1.703125 5.359375,-4.484375 0,-2.78125 -2.046875,-4.46875 -5.359375,-4.46875 z M 6.765625,-5.609375 H 4.03125 V -10.625 h 2.734375 c 2.046875,0 3.109375,0.921875 3.109375,2.5 0,1.59375 -1.0625,2.515625 -3.109375,2.515625 z m 0,0"
           id="path5846"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-26"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 3.546875,-1.796875 8.84375,-8.1875 V -9.609375 H 0.796875 V -7.8125 h 5.15625 L 0.6875,-1.421875 V 0 h 8.296875 v -1.796875 z m 0,0"
           id="path5849"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-27"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="M 10.875,-12.59375 6.640625,-2.875 2.453125,-12.59375 H -0.09375 L 5.421875,0 H 7.71875 l 5.5,-12.59375 z m 0,0"
           id="path5852"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-28"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 7.109375,0.1875 c 3.4375,0 5.515625,-2 5.515625,-5.671875 v -7.109375 h -2.3125 v 7.015625 c 0,2.59375 -1.15625,3.703125 -3.1875,3.703125 -2.03125,0 -3.203125,-1.109375 -3.203125,-3.703125 v -7.015625 h -2.34375 v 7.109375 c 0,3.671875 2.078125,5.671875 5.53125,5.671875 z m 0,0"
           id="path5855"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-29"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 15.484375,0 -0.01563,-12.59375 h -1.9375 L 8.625,-4.25 l -5,-8.34375 H 1.6875 V 0 H 3.921875 V -8.25 L 8.0625,-1.4375 H 9.109375 L 13.25,-8.359375 13.265625,0 Z m 0,0"
           id="path5858"
           inkscape:connector-curvature="0" />
      </symbol>
      <symbol
         overflow="visible"
         id="glyph3-30"
         style="overflow:visible">
        <path
           style="stroke:none"
           d="m 4.265625,-10.921875 h 1.9375 l 3.140625,-2.46875 H 6.703125 Z M 5.796875,0.125 c 2.984375,0 5.125,-2.046875 5.125,-4.9375 0,-2.875 -2.140625,-4.90625 -5.125,-4.90625 -2.953125,0 -5.109375,2.03125 -5.109375,4.90625 0,2.890625 2.15625,4.9375 5.109375,4.9375 z m 0,-1.921875 c -1.625,0 -2.84375,-1.171875 -2.84375,-3.015625 0,-1.828125 1.21875,-3 2.84375,-3 1.640625,0 2.859375,1.171875 2.859375,3 0,1.84375 -1.21875,3.015625 -2.859375,3.015625 z m 0,0"
           id="path5861"
           inkscape:connector-curvature="0" />
      </symbol>
    </g>
  </defs>
  <g
     id="surface139393"
     transform="translate(-448.77786,-294.00781)">
    <g
       id="SV11">
      <title
         id="title7094">AHUACHAPAN</title>
      <path
         inkscape:connector-curvature="0"
         id="path5992"
         d="m 623.86719,494.82422 c -0.66797,4.70312 -2.71875,10.5664 -5.6211,16.1875 -1.36328,2.64062 -3.4375,5.52734 -3.3125,8.21094 0.45703,9.65234 -5.90234,10.96875 -13.03125,11.82421 -1.89062,0.22657 -3.77734,0.52344 -5.65234,0.8711 -10.99219,2.02734 -11.58594,3.13672 -5.66406,12.63281 2.10156,3.375 1.13672,6.39844 -0.10547,9.31641 -4.47656,10.49218 -6.09766,21.41406 -5.66406,32.72265 0.14062,3.73438 -0.77344,6.92188 -4.01172,9.28516 -6.23438,4.55078 -8.17578,11.3125 -9.04297,18.51172 -0.95313,7.90625 -5.53906,11.83594 -13.08203,9.71484 -6.17578,-1.73828 -12.8086,-3.71094 -16.75782,-9.4414 -3.73828,-5.42579 -8.21093,-6.08204 -11.93359,-1.23047 -11.34766,14.80078 -23.94531,12.12109 -38.27344,4.86328 -11.625,-5.89063 -24.15234,-9.9961 -36.32031,-14.78906 -3.90234,-1.53907 -6.88281,-2.625 -1.67969,-6.72657 5.52735,-4.36328 1.02344,-8.82812 -1.59765,-11.92968 -3.95703,-4.6875 -2.82422,-9.22657 -3.25782,-14.57422 -1.04687,-12.84375 8.23829,-19.1836 13.58594,-28.01172 2.44141,-4.03125 7.02344,-4.92969 11.03906,-6.51563 4.14454,-1.63281 8.42188,-3.29297 9.27344,-8.28515 2.14453,-12.54297 10.90625,-18.37891 21.66016,-22.91797 14.1914,-5.98828 23.74609,-17.84766 33.86719,-28.74219 2.78125,-3 4.98046,-5.67578 9.30859,-5.21094 7.73047,0.83594 12.32812,-6.26172 19.5,-7.53125 5.15625,-0.91406 8.76953,-0.5 12.62109,2.85547 6.375,5.54688 13.70703,8.72656 22.46094,7.9961 4.92578,-0.41016 9.11719,0.90625 11.39844,6.0039 1.16015,2.59766 3.84765,3.76953 6.21484,5.10938 3.22266,1.82422 4.42188,4.65234 4.07813,9.80078"
         style="fill:#009ce1;fill-opacity:1;fill-rule:nonzero;stroke:none" />
      <g
         id="g6110"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6102"
           y="565.87793"
           x="467.9375"
           xlink:href="#glyph3-1" />
        <use
           height="100%"
           width="100%"
           id="use6104"
           y="565.87793"
           x="481.05951"
           xlink:href="#glyph3-2" />
        <use
           height="100%"
           width="100%"
           id="use6106"
           y="565.87793"
           x="493.02951"
           xlink:href="#glyph3-3" />
        <use
           height="100%"
           width="100%"
           id="use6108"
           y="565.87793"
           x="504.92749"
           xlink:href="#glyph3-4" />
      </g>
      <g
         id="g6114"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6112"
           y="565.87793"
           x="515.5835"
           xlink:href="#glyph3-5" />
      </g>
      <g
         id="g6122"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6116"
           y="565.87793"
           x="525.59149"
           xlink:href="#glyph3-2" />
        <use
           height="100%"
           width="100%"
           id="use6118"
           y="565.87793"
           x="537.56152"
           xlink:href="#glyph3-4" />
        <use
           height="100%"
           width="100%"
           id="use6120"
           y="565.87793"
           x="548.1275"
           xlink:href="#glyph3-6" />
      </g>
      <g
         id="g6128"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6124"
           y="565.87793"
           x="559.9895"
           xlink:href="#glyph3-7" />
        <use
           height="100%"
           width="100%"
           id="use6126"
           y="565.87793"
           x="570.55548"
           xlink:href="#glyph3-8" />
      </g>
    </g>
    <g
       id="SV02">
      <title
         id="title7075">SANTA ANA</title>
      <path
         inkscape:connector-curvature="0"
         id="path5988"
         d="m 757.375,294.00781 c 0.77734,6.16016 3.05469,7.40625 7.35156,8.76953 11.58203,3.67188 21.73828,11.24219 27.65235,21.57813 4.53125,7.91406 9.09375,14.65625 17.05859,18.89062 6.00781,3.19922 7.27344,7.60157 4.03906,13.52344 -1.03906,1.90625 -2.30078,3.91797 -2.54687,5.98828 -1.21094,10.16797 -6.4961,15.79688 -16.71094,18.02344 -10.01953,2.1875 -6,11.52344 -5.73828,17.08984 0.43359,9.41016 -3.04297,14.16407 -11.5586,15.53907 -11.83984,1.91015 -17.3164,12.72265 -26.57031,18.18359 -0.59765,0.35547 -1.30078,1.53125 -1.125,2.03906 3.23047,9.25781 -3.66797,15.02735 -7.15625,22.13281 -5.33203,10.85547 -1.7539,17.44532 10.35547,19.55469 4.98438,0.8711 4.87891,3.02735 3.46484,6.73047 -2.71093,7.10547 -5.58593,14.00781 -2.03906,22.01563 1.90235,4.28906 -2.63281,6.0625 -5.83594,7.39062 -6.65625,2.76563 -12.63671,6.38281 -17.24218,12.02734 -2.52344,3.08594 -4.19532,6.44922 -2.79297,10.53907 5.17969,15.12109 2.96875,29.10937 -5.77735,42.42187 -2.23828,3.40625 -4.07031,1.51172 -6.11718,0.69922 -9.40235,-3.73437 -18.23828,-8.57812 -26.6836,-14.11719 -5.85156,-3.83593 -11.78125,-4.3125 -17.53125,-0.26953 -3.10156,2.1836 -5.21875,1.63281 -7.91406,-0.5664 -8.24609,-6.73438 -16.27344,-13.58985 -22.70703,-22.22266 -4.80078,-6.44141 -10.25781,-11.98828 -19.64453,-10.77344 -4.28516,0.55469 -5.52735,-2.54297 -4.83985,-6.49609 0.8125,-4.63281 2.35547,-8.9961 5.06641,-12.82422 3.63281,-5.13281 4.36328,-11.09766 5.14063,-17.02344 0.53125,-4.04687 -0.66797,-7.73828 -4.55079,-9.71094 -4.14843,-2.10546 -5.8164,-6.26953 -8.70312,-9.35937 -7.83594,-8.38672 -5.59375,-17.15234 -1.94141,-25.84375 10.125,-24.10547 26.3711,-41.52734 53.73047,-44.52344 11.94922,-1.30859 21.58594,-8.4375 33.14844,-10.75 6.39453,-1.28125 4.92187,-8.98047 2.73828,-13.27344 -3.58594,-7.03906 -6.99219,-13.92578 -8.91797,-21.68359 -1.30469,-5.25781 -5.4375,-8.66797 -11.08203,-9.73828 -2.30469,-0.43359 -5.35156,0.008 -5.99609,-3.14453 -0.67969,-3.34766 1.15234,-6.01953 3.98047,-7.38672 6.9414,-3.35938 6.5039,-6.84766 1.05078,-11.38672 -2.76563,-2.29687 -3.34766,-5.78516 -1.375,-8.92187 2.51172,-3.9961 6.76172,-5.52344 11.19922,-5.8086 3.73046,-0.24219 3.72656,3.10547 4.39843,5.7461 1.22266,4.79296 4.5,5.19531 8.12891,2.96875 2.26953,-1.39454 3.88672,-3.8125 6.05078,-5.4336 8.41406,-6.30469 16.27344,-14.05859 28.37109,-7.07422 4.72266,2.72657 9.59375,0.26563 13.0625,-3.85547 2.07032,-2.46875 3.83985,-5.1875 7.10938,-9.66406"
         style="fill:#009ce1;fill-opacity:1;fill-rule:nonzero;stroke:none" />
      <g
         id="g6148"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6130"
           y="461.4599"
           x="634.97748"
           xlink:href="#glyph3-9" />
        <use
           height="100%"
           width="100%"
           id="use6132"
           y="461.4599"
           x="645.93951"
           xlink:href="#glyph3-4" />
        <use
           height="100%"
           width="100%"
           id="use6134"
           y="461.4599"
           x="656.50549"
           xlink:href="#glyph3-8" />
        <use
           height="100%"
           width="100%"
           id="use6136"
           y="461.4599"
           x="668.47552"
           xlink:href="#glyph3-10" />
        <use
           height="100%"
           width="100%"
           id="use6138"
           y="461.4599"
           x="675.7475"
           xlink:href="#glyph3-4" />
        <use
           height="100%"
           width="100%"
           id="use6140"
           y="461.4599"
           x="686.31348"
           xlink:href="#glyph3-11" />
        <use
           height="100%"
           width="100%"
           id="use6142"
           y="461.4599"
           x="690.92151"
           xlink:href="#glyph3-1" />
        <use
           height="100%"
           width="100%"
           id="use6144"
           y="461.4599"
           x="704.04352"
           xlink:href="#glyph3-8" />
        <use
           height="100%"
           width="100%"
           id="use6146"
           y="461.4599"
           x="716.01349"
           xlink:href="#glyph3-4" />
      </g>
    </g>
    <g
       id="SV06">
      <title
         id="title7110">SONSONATE</title>
      <path
         inkscape:connector-curvature="0"
         id="path5990"
         d="m 664.89453,686.55859 c -5.73047,6.78125 -12.59766,7.1875 -20.58984,4.39844 -14.73828,-5.14844 -29.69532,-0.21094 -44.55469,-0.28906 -1.62109,-0.004 -3.23438,0.46875 -4.86328,0.59375 -17.81641,1.40234 -22.89063,-1.85156 -25.8086,-19.30469 -1.5664,-9.37109 -6.61718,-14.73047 -13.92187,-19.81641 -12.3125,-8.5664 -25.70703,-15.14453 -39.8125,-22.66015 5.8125,-4.1211 10.60937,-7.89844 14.68359,-12.53906 3.51563,-4 6.71485,-3.33594 11.00391,0.30468 7.10547,6.03516 14.59766,12.21094 25.42578,9.29688 5.62109,-1.51172 8.48047,-4.36328 8.33594,-10.24219 -0.19922,-8.13672 2.15625,-15.10937 9.69531,-19.375 3.84375,-2.17578 3.81641,-5.84766 3.46875,-9.33203 -1.17187,-11.72266 1.25781,-22.79297 5.69922,-33.49609 1.96875,-4.74219 2.06641,-8.55079 -2.17578,-12.41016 -4.61328,-4.19922 -2.13281,-6.29688 2.98828,-7.16797 10.51172,-1.78125 21.13672,-2.00781 31.73047,-2.375 6.17578,-0.21484 9.84765,4.39453 12.64844,9.11719 6.76562,11.41015 17.85156,18.17969 27.55859,26.44531 2.41797,2.0625 4.17969,1.5625 6.07812,-0.91797 4.39454,-5.73047 9.53907,-5.32031 15.00391,-1.44531 7.60938,5.39453 16.07422,9.28125 24.58984,12.875 5.71875,2.41406 10.01172,6.44531 14.70704,10.11328 4.17968,3.26953 3.2539,6.75 -0.9961,7.86719 -7.13672,1.88281 -10.91406,6.33984 -13.84375,12.59765 -1.20703,2.57422 -3.89844,4.50391 -6.0625,6.57422 -5.51562,5.26172 -11.59375,10.08203 -9.48828,19.26563 0.42188,1.83203 -0.46484,4.75 -1.81641,6.08594 -12.29296,12.14843 -13.6875,31.48828 -28.01562,42.26953 -0.94531,0.71093 -1.16016,2.39453 -1.71875,3.6289 z m 0,0"
         style="fill:#009ce1;fill-opacity:1;fill-rule:nonzero;stroke:none" />
      <g
         id="g6166"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6150"
           y="617.98792"
           x="589.56348"
           xlink:href="#glyph3-9" />
        <use
           height="100%"
           width="100%"
           id="use6152"
           y="617.98792"
           x="600.52551"
           xlink:href="#glyph3-12" />
        <use
           height="100%"
           width="100%"
           id="use6154"
           y="617.98792"
           x="611.77551"
           xlink:href="#glyph3-8" />
        <use
           height="100%"
           width="100%"
           id="use6156"
           y="617.98792"
           x="623.74548"
           xlink:href="#glyph3-13" />
        <use
           height="100%"
           width="100%"
           id="use6158"
           y="617.98792"
           x="632.65552"
           xlink:href="#glyph3-12" />
        <use
           height="100%"
           width="100%"
           id="use6160"
           y="617.98792"
           x="643.90552"
           xlink:href="#glyph3-8" />
        <use
           height="100%"
           width="100%"
           id="use6162"
           y="617.98792"
           x="655.87549"
           xlink:href="#glyph3-4" />
        <use
           height="100%"
           width="100%"
           id="use6164"
           y="617.98792"
           x="666.44153"
           xlink:href="#glyph3-10" />
      </g>
      <g
         id="g6170"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6168"
           y="617.98792"
           x="673.38953"
           xlink:href="#glyph3-14" />
      </g>
    </g>
    <g
       id="SV04">
      <title
         id="title7133">LA LIBERTAD</title>
      <path
         inkscape:connector-curvature="0"
         id="path5986"
         d="m 664.84375,686.61719 c 9.28125,-8.64844 20.03906,-16.05469 22.21875,-30.15625 0.75,-4.84375 4.41797,-8.71875 7.98828,-12.14453 3.61328,-3.46094 6.10938,-8.3125 4.87109,-12.42579 -1.91406,-6.37109 1.48438,-9.15625 5.24219,-12.21093 4.87891,-3.96485 9.8086,-7.59766 11.57813,-14.27735 0.98047,-3.67968 4.73047,-4.69922 8.34375,-5.68359 8.16015,-2.22656 9.59765,-7.40625 3.6875,-13.30078 -4.4336,-4.42578 -4.90235,-9.64844 -1.66016,-14.04297 8.25391,-11.19531 7.14453,-23.47266 5.0625,-35.76953 -1.41406,-8.35547 0.5,-14.03516 8.125,-18.19531 2.86719,-1.5625 5.72656,-3.15625 8.69531,-4.51172 6.83203,-3.11719 8.86719,-6.82422 7.00782,-15.28125 -1.8086,-8.23828 1.98046,-16.73047 8.80859,-23.80469 5.56641,-5.76172 10.64844,-10.28516 18.63672,-12.75781 9.44531,-2.92969 14.14453,5.82422 21.79297,6.4375 0.99609,0.0781 1.26172,1.9414 0.5664,2.82422 -5.88672,7.45703 -0.23047,13.8789 1.69141,20.66015 1.38672,4.90625 4.33594,9.32813 3.57031,14.91406 -0.67969,4.9375 4.01172,5.10157 7.11719,6.33594 6,2.37891 12.79687,4.03516 5.01172,12.3125 -1.55078,1.64844 -1.10938,5.19141 -1.55469,7.86719 -1.78906,10.74609 -3.00781,21.625 -8.94141,31.21094 -2.23046,3.60547 -2.30078,7.78906 -2.21484,11.91015 0.15625,7.45703 -0.62891,14.30469 -5.68359,20.69922 -5.08594,6.42969 2.98828,24.11719 12.71484,28.30469 7.23828,3.11328 10.33203,5.92187 2.90234,12.41797 -2.89062,2.52734 -2.32812,6.52344 0.375,9.59765 1.0625,1.21094 3.58594,2.54688 3.38672,3.24219 -2.66406,9.36328 3.00782,18.53516 1.07813,27.37891 -1.75391,8.05859 -2.08985,14.875 3.05469,21.58594 1.46093,1.89843 2.3125,4.32031 3.18359,6.60546 1.83203,4.80079 3.1875,8.94532 9.41797,3.51172 4.08594,-3.5664 15.74219,-0.35547 15.94922,4.49219 0.27734,6.53125 -1.16797,13.31641 -1.69922,20.02344 -0.25391,3.1875 -4.625,0.7539 -6.91016,-0.32031 -12.83203,-6.02735 -25.625,-12.13282 -38.39062,-18.29297 -8.69141,-4.19532 -17.3125,-7.67578 -27.46094,-5.42578 -3.42578,0.75781 -7.59766,-0.60157 -11.14063,-1.82032 -17.92187,-6.16406 -36.22265,-5.83984 -54.80859,-4.5039 -17.58594,1.26172 -34.72266,-2.82813 -51.52734,-7.48828 -8.67188,-2.40625 1.14062,-6.58985 -0.0352,-9.97657 z m 0,0"
         style="fill:#009ce1;fill-opacity:1;fill-rule:nonzero;stroke:none" />
      <g
         id="g6176"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6172"
           y="669.0719"
           x="699.30951"
           xlink:href="#glyph3-15" />
        <use
           height="100%"
           width="100%"
           id="use6174"
           y="669.0719"
           x="709.82147"
           xlink:href="#glyph3-4" />
      </g>
      <g
         id="g6184"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6182"
           y="669.0719"
           x="724.99548"
           xlink:href="#glyph3-15" />
      </g>
      <g
         id="g6188"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6186"
           y="669.0719"
           x="735.41748"
           xlink:href="#glyph3-16" />
      </g>
      <g
         id="g6192"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6190"
           y="669.0719"
           x="740.25952"
           xlink:href="#glyph3-17" />
      </g>
      <g
         id="g6196"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6194"
           y="669.0719"
           x="752.2475"
           xlink:href="#glyph3-14" />
      </g>
      <g
         id="g6200"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6198"
           y="669.0719"
           x="763.0835"
           xlink:href="#glyph3-18" />
      </g>
      <g
         id="g6204"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6202"
           y="669.0719"
           x="770.55353"
           xlink:href="#glyph3-10" />
      </g>
      <g
         id="g6210"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6206"
           y="669.0719"
           x="777.8255"
           xlink:href="#glyph3-4" />
        <use
           height="100%"
           width="100%"
           id="use6208"
           y="669.0719"
           x="788.48151"
           xlink:href="#glyph3-19" />
      </g>
    </g>
    <g
       id="SV09">
      <title
         id="title7205">CHALATENANGO</title>
      <path
         inkscape:connector-curvature="0"
         id="path5984"
         d="m 780.10547,308.25391 c 9.39453,-0.35938 16.52344,1.95703 23.26172,5.66796 6.76953,3.72657 13.68359,6.7461 21.6875,6.16797 2.86328,-0.20703 5.51562,0.72657 7.19922,3.13672 6.82031,9.75 17.89062,9.10938 27.72265,11.3086 3.12891,0.70312 5.64453,-1.52735 7.63672,-3.94922 2.07422,-2.51953 3.97266,-5.23047 6.31641,-7.48047 3.03125,-2.91016 5.96875,-7.46485 10.96875,-4.98828 4.51562,2.23828 4.25,7.27734 4.27343,11.62109 0.0664,12.80078 -0.0234,12.98438 13.03125,15.0625 10.00782,1.59375 10.58204,9.97656 10.98047,16.76172 0.48047,8.15234 3.13282,12.89453 10.60547,16.28125 5.15235,2.33203 8.96094,7.17969 10.31641,13.05859 2.09765,9.08594 7.7539,13.51953 16.83594,12.03907 6.37109,-1.04297 12.51171,-2.52344 16.5664,4.5039 0.23828,0.41797 0.89063,0.86719 1.33985,0.85547 14.71093,-0.39062 16.34375,11.55078 20.28906,21.36719 0.80469,2.0039 2.32812,3.73437 3.04687,5.75781 2.78516,7.85156 8.16011,9.22266 15.46481,6.75 3.7305,-1.26562 7.3907,-1.4375 10.6641,1.67969 3.8164,3.625 8.1992,1.60156 12.4023,0.70703 8.4141,-1.79297 10.4375,0.37891 8.1094,8.74219 -0.289,1.04687 -0.7969,2.03125 -1.1289,3.0664 -2.5781,8.0625 -0.1836,12.16407 8.1953,14.35938 5.8282,1.52344 14.3867,1.19531 13.3907,9.86719 -0.9063,7.89843 -9.5079,7.48828 -15.1993,7.71875 -9.5703,0.3789 -18.3242,1.02343 -25.0195,9.13671 -1.4688,1.77735 -4.9336,1.9375 -7.5039,2.77344 -11.4219,3.72266 -23.53907,5.54688 -33.77344,12.52735 -2.29297,1.5625 -5.52344,3.01562 -7.71485,1.51562 -9.90625,-6.76953 -20.60156,-1.82812 -30.85547,-2.5 -14.96484,-0.98437 -20.11328,-4.37891 -22.5,-19.05859 -2.5039,-15.35547 -9.60937,-25.71094 -25.83203,-28.41016 -6.16406,-1.02734 -12.16015,-3 -18.28125,-4.31641 -2.08203,-0.44921 -5.01562,-1.13281 -6.36719,-0.12109 -9.29296,6.97266 -20.26953,5.08594 -30.625,6.4375 -0.80468,0.10156 -1.82421,0.77734 -2.35156,0.48047 -10.29297,-5.80078 -21.66015,0.61719 -32.12109,-2.89063 -0.76953,-0.25781 -1.79688,-0.29296 -2.26563,-0.82421 -4.90234,-5.50391 -10.44531,-5.51563 -17.03125,-3.10547 -5.88281,2.15234 -11.88672,3.20703 -15.90625,9 -2.90234,4.1875 -17.61718,4.60547 -21.39062,1.375 -1.85938,-1.59766 -2.28125,-3.60547 -1.90235,-5.90235 0.75782,-4.625 1.76563,-9.35937 4.99219,-12.78125 3.75391,-3.98437 4.41406,-8.27343 5.38281,-13.55078 1.86329,-10.10156 10.61329,-15.80859 19.36719,-20.40625 2.59375,-1.36328 5.72656,-1.71484 8.6211,-2.48437 6.71875,-1.77735 10.08593,-6.06641 9.91796,-13.07032 -0.0469,-1.90625 0.14063,-3.82812 -0.0508,-5.71875 -0.92968,-9.1914 2.16797,-15.0625 12.21094,-16.07421 4.53125,-0.46094 6.98438,-3.76954 8.32422,-8.01172 1.80078,-5.71875 3.51562,-11.48438 5.71875,-17.05078 2.44922,-6.1875 0.92969,-10.86719 -4.875,-13.65235 -7.98828,-3.83594 -13.66016,-9.13281 -16.62891,-17.92187 -2.22265,-6.58594 -9.16015,-9.78516 -15.51562,-15.45703"
         style="fill:#009ce1;fill-opacity:1;fill-rule:nonzero;stroke:none" />
      <use
         xlink:href="#glyph3-20"
         x="806.39148"
         y="427.8179"
         id="use6212"
         width="100%"
         height="100%"
         style="fill:#fafafa;fill-opacity:1" />
      <use
         xlink:href="#glyph3-2"
         x="819.11749"
         y="427.8179"
         id="use6214"
         width="100%"
         height="100%"
         style="fill:#fafafa;fill-opacity:1" />
      <use
         xlink:href="#glyph3-4"
         x="831.08752"
         y="427.8179"
         id="use6216"
         width="100%"
         height="100%"
         style="fill:#fafafa;fill-opacity:1" />
      <use
         xlink:href="#glyph3-21"
         x="841.6535"
         y="427.8179"
         id="use6218"
         width="100%"
         height="100%"
         style="fill:#fafafa;fill-opacity:1" />
      <use
         xlink:href="#glyph3-4"
         x="846.49548"
         y="427.8179"
         id="use6220"
         width="100%"
         height="100%"
         style="fill:#fafafa;fill-opacity:1" />
      <use
         xlink:href="#glyph3-10"
         x="857.06152"
         y="427.8179"
         id="use6222"
         width="100%"
         height="100%"
         style="fill:#fafafa;fill-opacity:1" />
      <use
         xlink:href="#glyph3-14"
         x="864.00952"
         y="427.8179"
         id="use6226"
         width="100%"
         height="100%"
         style="fill:#fafafa;fill-opacity:1" />
      <use
         xlink:href="#glyph3-8"
         x="874.84552"
         y="427.8179"
         id="use6228"
         width="100%"
         height="100%"
         style="fill:#fafafa;fill-opacity:1" />
      <use
         xlink:href="#glyph3-4"
         x="886.81549"
         y="427.8179"
         id="use6230"
         width="100%"
         height="100%"
         style="fill:#fafafa;fill-opacity:1" />
      <use
         xlink:href="#glyph3-8"
         x="897.38147"
         y="427.8179"
         id="use6232"
         width="100%"
         height="100%"
         style="fill:#fafafa;fill-opacity:1" />
      <use
         xlink:href="#glyph3-22"
         x="909.44153"
         y="427.8179"
         id="use6236"
         width="100%"
         height="100%"
         style="fill:#fafafa;fill-opacity:1" />
      <use
         xlink:href="#glyph3-12"
         x="921.57349"
         y="427.8179"
         id="use6238"
         width="100%"
         height="100%"
         style="fill:#fafafa;fill-opacity:1" />
    </g>
    <g
       id="SV01">
      <path
         inkscape:connector-curvature="0"
         id="path5982"
         d="m 863.39844,464.25391 c -5.82813,6.37109 -7.625,12.85546 -5.94922,20.80468 0.77344,3.66797 -1.4375,7.42969 -3.20703,10.8125 -4.63672,8.875 -3.03516,16.76953 3.3164,24.13282 3.19922,3.70703 6.03516,7.73828 9.30078,11.38671 4.91016,5.47657 3.44532,8.92579 -2.92968,11.56641 -2.9961,1.24219 -8.10938,1.57422 -6.55469,6.55469 1.3125,4.21875 3.38281,8.9414 9.60547,8.07422 4.26172,-0.59375 6.07812,1.80468 7.77734,5.51953 3.3086,7.23828 5.8711,15.67578 16.48828,15.45312 2.14063,-0.043 2.8711,2.26563 3.65625,4 4.14453,9.1836 8.17969,18.42188 12.45703,27.54688 1.9336,4.125 1.28125,6.21094 -3.60156,6.09375 -1.90625,-0.0469 -3.8164,0 -5.72265,0.0195 -13,0.125 -16.57813,4.38672 -14.51172,17.13672 0.51953,3.21875 0.85156,6.47656 1.11328,9.73047 0.57031,7.07422 -3.60156,11.87109 -10.8125,12.39062 -4.07031,0.29297 -8.21875,-0.008 -12.21875,0.64844 -6.85938,1.13672 -9.02735,4.91016 -4.79297,10.16797 10.16016,12.61719 4.83203,23.67578 -1.75391,35.17578 -2.07422,3.625 -4.41015,5.33984 -8.50781,4.32812 -0.79297,-0.19531 -1.70703,-0.14453 -2.38281,-0.53515 -3.46875,-2.00781 -7.04297,6.86328 -10.22266,0.0586 -3.75781,-8.05078 -11.77344,-15.21484 -5.99609,-25.54297 0.13281,-0.23437 0.28515,-0.49218 0.3125,-0.75 1.05469,-9.95312 -3.91016,-19.78906 -0.63672,-29.84765 0.18359,-0.56641 -1.625,-2.06641 -2.74609,-2.72657 -4.11329,-2.41796 -4.35938,-4.67187 -0.89454,-8.2539 5.91797,-6.1211 5.16016,-9.71094 -2.14843,-13.91797 -14.64063,-8.42578 -17.1836,-16.02344 -10.83985,-32.05859 0.79688,-2.01172 1.83594,-4.24219 1.65625,-6.27344 -1.6875,-19.11719 11.70703,-34.82422 11.96094,-53.4961 0.043,-3.26953 1.69531,-6.10546 4.36719,-8.45312 4.39062,-3.85938 2.89844,-8.41016 -1.71875,-9.43359 -10.42969,-2.32032 -12.58203,-10.25782 -15.08985,-18.51563 -1.10546,-3.63672 -2.48046,-7.24609 -4.21484,-10.625 -2.79297,-5.44141 -1.73828,-9.98047 2.47656,-14.02734 4.41407,-4.24219 9.39453,-6.875 15.44141,-3.64063 4.17969,2.23438 8.14062,2.71094 12.45312,0.6211 1.1836,-0.57032 2.85938,-1.17969 3.92579,-0.76954 7.55468,2.88672 14.29296,1.23047 21.14453,-3.35546"
         style="fill:#009ce1;fill-opacity:1;fill-rule:nonzero;stroke:none" />
      <g
         id="g7176"
         transform="translate(43.474577,-9.006356)">
        <use
           height="100%"
           width="100%"
           id="use6242"
           y="599.75391"
           x="794.09747"
           xlink:href="#glyph3-9"
           style="fill:#fafafa;fill-opacity:1" />
        <use
           height="100%"
           width="100%"
           id="use6244"
           y="599.75391"
           x="805.05951"
           xlink:href="#glyph3-4"
           style="fill:#fafafa;fill-opacity:1" />
        <use
           height="100%"
           width="100%"
           id="use6246"
           y="599.75391"
           x="815.62549"
           xlink:href="#glyph3-8"
           style="fill:#fafafa;fill-opacity:1" />
      </g>
      <use
         style="fill:#fafafa;fill-opacity:1"
         xlink:href="#glyph3-11"
         x="827.59552"
         y="599.75391"
         id="use6248"
         width="100%"
         height="100%" />
      <g
         id="g7171"
         transform="translate(-16.924318,9.7245764)">
        <use
           height="100%"
           width="100%"
           id="use6250"
           y="599.75391"
           x="832.20349"
           xlink:href="#glyph3-9"
           style="fill:#fafafa;fill-opacity:1" />
        <use
           height="100%"
           width="100%"
           id="use6252"
           y="599.75391"
           x="843.16553"
           xlink:href="#glyph3-4"
           style="fill:#fafafa;fill-opacity:1" />
        <use
           height="100%"
           width="100%"
           id="use6254"
           y="599.75391"
           x="853.73151"
           xlink:href="#glyph3-21"
           style="fill:#fafafa;fill-opacity:1" />
        <use
           height="100%"
           width="100%"
           id="use6256"
           y="599.75391"
           x="858.57349"
           xlink:href="#glyph3-23"
           style="fill:#fafafa;fill-opacity:1" />
        <g
           style="fill:#fafafa;fill-opacity:1"
           id="g6262">
          <use
             xlink:href="#glyph3-4"
             x="868.31152"
             y="599.75391"
             id="use6260"
             width="100%"
             height="100%" />
        </g>
        <g
           style="fill:#fafafa;fill-opacity:1"
           id="g6270">
          <use
             xlink:href="#glyph3-19"
             x="878.96753"
             y="599.75391"
             id="use6264"
             width="100%"
             height="100%" />
          <use
             xlink:href="#glyph3-12"
             x="890.97351"
             y="599.75391"
             id="use6266"
             width="100%"
             height="100%" />
          <use
             xlink:href="#glyph3-18"
             x="902.22351"
             y="599.75391"
             id="use6268"
             width="100%"
             height="100%" />
        </g>
      </g>
    </g>
    <g
       id="SV10">
      <title
         id="title7042">CUSCATLAN</title>
      <path
         inkscape:connector-curvature="0"
         id="path5980"
         d="m 936.55078,524.54687 c -9.08984,4.41797 -8.17187,12.8125 -7.31641,20.47266 0.71875,6.42578 6.42188,9.55078 12.0586,10.75391 7.13281,1.52343 9.63281,8.66406 15.60937,11.35547 0.69141,0.3164 1.44922,2.0664 1.16797,2.70703 -3.875,8.85937 3.19531,9.08593 8.38672,11.03125 3.29688,1.24218 6.51172,2.79297 9.58984,4.51562 7.00782,3.92969 9.25391,9.40625 5.65235,17.09375 -2.61328,5.57031 -4.5625,11.05078 -4.50781,17.80469 0.0469,5.44922 -6.44141,9.08984 -12.31641,10.28516 -6.67969,1.35546 -13.64453,1.43359 -15.92578,10.08203 -0.875,3.32031 -4.15625,1.80859 -6.23047,0.64843 -12.27734,-6.85546 -25.44531,-12.26562 -30.74219,-27.54296 -3.90625,-11.26172 -9.91015,-21.80079 -15.01172,-32.64454 -1.13672,-2.41796 -1.8789,-5.48046 -5.3164,-5.47265 -8.56641,0.0156 -11.4375,-6.39844 -14,-12.67188 -2.05078,-5.02343 -4.64063,-8.625 -10.53907,-8.4375 -2.86718,0.0859 -4.73828,-1.32812 -5.59765,-3.87109 -1.16016,-3.42188 1.94922,-3.92969 3.89844,-5.16797 10.16796,-6.45703 10.33984,-7.34375 3.08984,-16.59375 -2.18359,-2.78516 -4.21875,-5.72266 -6.66016,-8.26953 -7.73437,-8.07422 -9.24218,-16.92188 -3.9414,-26.87109 1.85937,-3.48438 2.15625,-7.35938 1.75781,-11.16407 -0.55859,-5.27734 1.5,-9.29297 4.52344,-13.46875 4.08593,-5.63281 8.75781,-7.90234 15.41015,-5.375 0.50782,0.19532 1.05078,0.29688 1.58594,0.39453 19.17188,3.45313 32.49609,12.01954 33.93359,33.97266 0.64063,9.79688 10.33204,16.21484 20.16407,16.62891 1.86718,0.082 3.73047,0.35156 5.88281,0.5664 0.32031,4.3125 -4.61719,5.62891 -4.65625,9.30078 z m 0,0"
         style="fill:#009ce1;fill-opacity:1;fill-rule:nonzero;stroke:none" />
      <g
         id="g1210"
         transform="translate(-1.2134671,-0.20224453)">
        <g
           transform="translate(40.042373,36.61017)"
           id="g1186">
          <g
             id="g6276"
             style="fill:#fafafa;fill-opacity:1">
            <use
               height="100%"
               width="100%"
               id="use6272"
               y="532.14587"
               x="848.02551"
               xlink:href="#glyph3-20" />
            <use
               height="100%"
               width="100%"
               id="use6274"
               y="532.14587"
               x="860.48151"
               xlink:href="#glyph3-3" />
          </g>
          <g
             id="g6280"
             style="fill:#fafafa;fill-opacity:1">
            <use
               height="100%"
               width="100%"
               id="use6278"
               y="532.14587"
               x="872.37952"
               xlink:href="#glyph3-13" />
          </g>
          <g
             id="g6284"
             style="fill:#fafafa;fill-opacity:1">
            <use
               height="100%"
               width="100%"
               id="use6282"
               y="532.14587"
               x="881.28949"
               xlink:href="#glyph3-5" />
          </g>
          <g
             id="g6288"
             style="fill:#fafafa;fill-opacity:1">
            <use
               height="100%"
               width="100%"
               id="use6286"
               y="532.14587"
               x="891.38751"
               xlink:href="#glyph3-4" />
          </g>
        </g>
        <g
           transform="translate(40.042373,36.61017)"
           id="g1175">
          <g
             id="g6292"
             style="fill:#fafafa;fill-opacity:1"
             transform="translate(-39.756356,17.447034)">
            <use
               height="100%"
               width="100%"
               id="use6290"
               y="532.14587"
               x="901.95349"
               xlink:href="#glyph3-10" />
          </g>
          <g
             id="g6296"
             style="fill:#fafafa;fill-opacity:1"
             transform="translate(-39.756356,17.447034)">
            <use
               height="100%"
               width="100%"
               id="use6294"
               y="532.14587"
               x="909.22552"
               xlink:href="#glyph3-21" />
          </g>
          <g
             id="g6300"
             style="fill:#fafafa;fill-opacity:1"
             transform="translate(-39.756356,17.447034)">
            <use
               height="100%"
               width="100%"
               id="use6298"
               y="532.14587"
               x="914.0675"
               xlink:href="#glyph3-7" />
          </g>
          <g
             id="g6304"
             style="fill:#fafafa;fill-opacity:1"
             transform="translate(-39.756356,17.447034)">
            <use
               height="100%"
               width="100%"
               id="use6302"
               y="532.14587"
               x="924.63348"
               xlink:href="#glyph3-8" />
          </g>
        </g>
        <rect
           y="563.21106"
           x="942.65765"
           height="1.787606"
           width="5.4343219"
           id="rect1188"
           style="color:#000000;clip-rule:nonzero;display:inline;overflow:visible;visibility:visible;opacity:1;isolation:auto;mix-blend-mode:normal;color-interpolation:sRGB;color-interpolation-filters:linearRGB;solid-color:#000000;solid-opacity:1;vector-effect:none;fill:#fefefe;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:54.42367172;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:0.40000006;color-rendering:auto;image-rendering:auto;shape-rendering:auto;text-rendering:auto;enable-background:accumulate" />
      </g>
    </g>
    <g
       id="SV14">
      <title
         id="title7060">CABAÑAS</title>
      <path
         inkscape:connector-curvature="0"
         id="path5976"
         d="m 936.5,524.60937 c 2.73047,-1.77734 5.64844,-3.32812 8.16016,-5.3789 7.09765,-5.79688 14.05859,-8.66797 22.90625,-2.80078 4.80468,3.18359 10.30859,0.83984 14.19921,-2.82032 3.09375,-2.91406 6.85157,-2.72265 10.15625,-4.13281 10.98833,-4.67187 24.04293,-4.47656 33.08983,-13.67969 2.8946,-2.94531 6.3516,-4.26953 10.336,-3.9375 11.0156,0.92188 20.9453,-3.29687 30.8711,-6.86328 11.1953,-4.02343 31.7617,0.50391 38.5078,10.07032 3.0742,4.35156 6.3242,5.60546 11.039,4.35546 4.7188,-1.25781 9.2383,-0.58593 13.5391,1.45704 5.7109,2.71484 9.2851,5.78906 5.4961,13.23437 -4.0977,8.05859 -3.6406,15.70313 1.75,24.46094 6.4023,10.39453 -0.3555,21.33984 -4.2852,31.65625 -3.3047,8.66406 -10.2148,15.86719 -10.4218,25.80078 -0.02,0.95703 -0.5352,2.17969 -1.2422,2.80078 -3.0352,2.66406 -22.6563,-0.95703 -23.961,-4.82422 -1.2773,-3.76562 -3.7422,-5.05469 -6.9609,-6.01562 -5.7813,-1.73047 -11.2813,-3.86328 -15.8399,-8.12891 -1.4609,-1.36328 -4.0546,-2.55078 -5.914,-2.28906 -11.4883,1.59765 -22.7383,1.11328 -33.9805,-1.89063 -2.0898,-0.55468 -5.0117,0.40235 -7.0508,1.54297 -10.582,5.94531 -23.2734,5.46485 -33.85934,11.39844 -3.5,1.96484 -6.9375,0.35547 -9.92188,-1.80859 -5.78125,-4.1875 -11.83203,-7.78907 -18.84375,-9.5625 -1.8125,-0.45704 -4.49219,-1.07422 -3.86719,-3.375 3.34375,-12.23438 -8.14843,-14.66797 -14.05468,-18.24219 -16.96875,-10.26563 -18.67188,-12.95313 -9.79688,-31.08985 z m 0,0"
         style="fill:#009ce1;fill-opacity:1;fill-rule:nonzero;stroke:none" />
      <g
         id="g6310"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6306"
           y="541.6499"
           x="983.3855"
           xlink:href="#glyph3-20" />
        <use
           height="100%"
           width="100%"
           id="use6308"
           y="541.6499"
           x="996.02148"
           xlink:href="#glyph3-4" />
      </g>
      <g
         id="g6314"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6312"
           y="541.6499"
           x="1006.5875"
           xlink:href="#glyph3-17" />
      </g>
      <g
         id="g6318"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6316"
           y="541.6499"
           x="1018.4495"
           xlink:href="#glyph3-4" />
      </g>
      <g
         id="g6322"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6320"
           y="541.6499"
           x="1029.0155"
           xlink:href="#glyph3-24" />
      </g>
      <g
         id="g6326"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6324"
           y="541.6499"
           x="1040.9855"
           xlink:href="#glyph3-4" />
      </g>
      <g
         id="g6330"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6328"
           y="541.6499"
           x="1051.5515"
           xlink:href="#glyph3-13" />
      </g>
    </g>
    <g
       id="SV08">
      <title
         id="title7219">LA PAZ</title>
      <path
         inkscape:connector-curvature="0"
         id="path5978"
         d="m 901.41016,618.04297 c 6.76953,-0.59766 12.03906,3.0625 16.24609,9.74219 6.44922,10.25 18.39062,12.2539 28.26953,17.22656 3.24609,1.63281 5.49219,-1.24219 6.69141,-4.32031 1.76172,-4.54297 5.04687,-7.54297 9.91406,-6.90625 4.69922,0.62109 5.87891,5.59765 5.65234,8.91015 -0.99218,14.58594 4.83594,21.86719 19.62891,24.90235 8.9375,1.83593 16.6094,26.71875 12.9023,35.45312 -5.7773,13.62109 -3.08589,25.50781 7.0469,36.00391 5.3789,5.57031 8.6641,11.9414 6.7344,19.96875 -0.8359,3.46093 -1.9492,6.83984 -5.2578,8.91406 -3.7735,2.36328 -4.1328,5.57422 -1.8477,9.09766 1.9102,2.95312 2.5,5.33984 -1.2617,7.33593 -6.38671,3.38672 -10.07812,9.125 -12.47656,15.64453 -1.73437,4.71485 -4.17968,5.88672 -8.57031,3.30469 -38.91797,-22.875 -81.94531,-37.64844 -120.58203,-61.08984 -4.66016,-2.82422 -8.60938,-16.79297 -4.9375,-20.83203 2.92578,-3.21875 2.47656,-5.66016 0.78125,-8.70313 -3.01563,-5.41015 -3.12109,-9.97265 0.59766,-15.80469 5.96875,-9.36328 8.14843,-19.67578 -0.38672,-29.42578 -1.52344,-1.73828 -3.625,-3.92187 -2.28125,-6.53515 1.34375,-2.61328 4.27734,-1.85547 6.65234,-1.9961 5.86719,-0.35547 11.59375,0.53907 17.16016,-3.48437 8.80859,-6.3711 5.00781,-14.57031 4.46093,-22.20703 -0.85156,-11.94141 1.89063,-15.32032 14.86329,-15.19922"
         style="fill:#009ce1;fill-opacity:1;fill-rule:nonzero;stroke:none" />
      <g
         id="g6336"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6332"
           y="711.33588"
           x="887.82349"
           xlink:href="#glyph3-15" />
        <use
           height="100%"
           width="100%"
           id="use6334"
           y="711.33588"
           x="898.33551"
           xlink:href="#glyph3-4" />
      </g>
      <g
         id="g6344"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6342"
           y="711.33588"
           x="913.50952"
           xlink:href="#glyph3-25" />
      </g>
      <g
         id="g6348"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6346"
           y="711.33588"
           x="925.94751"
           xlink:href="#glyph3-4" />
      </g>
      <g
         id="g6352"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6350"
           y="711.33588"
           x="936.51349"
           xlink:href="#glyph3-26" />
      </g>
    </g>
    <g
       id="SV13">
      <title
         id="title7239">SAN VICENTE</title>
      <path
         inkscape:connector-curvature="0"
         id="path5974"
         d="m 1036.1133,578.89062 c 9.1133,3.25782 20.4414,2.57813 31.8203,1.74219 2.7812,-0.20703 5.1719,1.60938 7.1953,3.50391 3.2539,3.05469 6.9492,5.21094 11.3281,6.22265 1.3125,0.30079 3.2305,0.60157 3.6993,1.51172 5.6757,10.96875 16.0351,9.375 25.6601,9.92188 1.2774,0.0742 3.375,0.62109 3.6328,1.42187 2.8711,8.86328 12.8242,11.25 17.0469,18.95313 1.5469,2.82422 1.7266,4.30859 -0.9375,5.94531 -0.4648,0.28516 -0.8711,0.69922 -1.3711,0.88672 -13.3594,5.07812 -21.2734,15.60547 -27.1914,27.82812 -3.3047,6.83204 -8.9023,9.3711 -15.7109,9.90235 -7.6641,0.60156 -13.9414,2.66797 -16.0547,11.125 -0.2422,0.97265 -1.0117,2.375 -1.793,2.57422 -12.0391,3.03125 -11.5039,13.29297 -12.3242,22.21093 -1.3281,14.48438 -5.5547,27.39063 -15.1524,38.73438 -4.2968,5.08203 -6.7421,11.77734 -9.7304,17.88281 -0.9102,1.86328 -1.7266,4.58203 -1.0391,6.28125 5.957,14.71485 -6.5195,20.26172 -14.1797,27.41797 -6.2265,5.8125 -17.0078,7.04297 -16.9961,18.67188 0,1.76953 -1.9687,1.5625 -3.2304,0.89453 -3.17583,-1.6875 -6.80864,-3.51953 -5.44926,-7.92578 2.17968,-7.03907 4.62109,-14.09375 12.07026,-17.63672 4.7735,-2.27344 6.6133,-5.48828 3.254,-10.40625 -1.7266,-2.52735 -1.6016,-4.39063 0.9882,-6.95703 7.6641,-7.59766 8.3711,-18.73438 2.3399,-27.55469 -1.8438,-2.69141 -3.7617,-5.40235 -6.0391,-7.71485 -9.12108,-9.25781 -9.89451,-19.85546 -4.2305,-30.78125 2.8516,-5.5039 3.1602,-10.04296 0.1211,-15.28515 -1.7656,-3.04297 -3.0078,-6.41797 -4.24214,-9.73438 -3.41797,-9.1875 -8.27344,-16.35156 -19.47266,-16.71484 -5.46094,-0.17578 -8.02344,-3.73438 -7.98438,-9.34766 0.0234,-2.96484 -0.29296,-6.10156 -1.27343,-8.87109 -2.85938,-8.10547 -0.23438,-13.62109 7.10547,-17.51953 2.14062,-1.14063 4.625,-2.89063 3.36718,-5.76953 -4.32812,-9.89063 3.40625,-17.01563 5.66016,-25.34766 1.01953,-3.76562 5.59766,-2.5625 8.42578,-3.88281 9.66012,-4.51563 20.52342,-5.48438 30.02342,-10.42578 2.6797,-1.39453 5.5703,-2.2461 10.6641,-1.75782"
         style="fill:#009ce1;fill-opacity:1;fill-rule:nonzero;stroke:none" />
      <g
         id="g6364"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6354"
           y="642.6839"
           x="994.0235"
           xlink:href="#glyph3-9" />
        <use
           height="100%"
           width="100%"
           id="use6356"
           y="642.6839"
           x="1004.9855"
           xlink:href="#glyph3-4" />
        <use
           height="100%"
           width="100%"
           id="use6358"
           y="642.6839"
           x="1015.5515"
           xlink:href="#glyph3-8" />
        <use
           height="100%"
           width="100%"
           id="use6360"
           y="642.6839"
           x="1027.5215"
           xlink:href="#glyph3-11" />
        <use
           height="100%"
           width="100%"
           id="use6362"
           y="642.6839"
           x="1032.1295"
           xlink:href="#glyph3-27" />
      </g>
      <g
         id="g6370"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6366"
           y="642.6839"
           x="1044.7115"
           xlink:href="#glyph3-16" />
        <use
           height="100%"
           width="100%"
           id="use6368"
           y="642.6839"
           x="1049.5535"
           xlink:href="#glyph3-5" />
      </g>
      <g
         id="g6378"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6372"
           y="642.6839"
           x="1059.5074"
           xlink:href="#glyph3-14" />
        <use
           height="100%"
           width="100%"
           id="use6374"
           y="642.6839"
           x="1070.3435"
           xlink:href="#glyph3-8" />
        <use
           height="100%"
           width="100%"
           id="use6376"
           y="642.6839"
           x="1082.3135"
           xlink:href="#glyph3-10" />
      </g>
      <g
         id="g6382"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6380"
           y="642.6839"
           x="1089.2615"
           xlink:href="#glyph3-14" />
      </g>
    </g>
    <g
       id="SV05">
      <title
         id="title7253">USULUTAN</title>
      <path
         inkscape:connector-curvature="0"
         id="path5972"
         d="m 1144.582,829.28125 c -5.2578,0.39844 -9.7148,-0.78516 -14.2109,-1.72656 -3.3359,-0.69532 -4.8984,-2.61328 -5.707,-5.9961 -2.3907,-10.04297 -7.7852,-16.88672 -18.9805,-18.41797 -8.3359,-1.13671 -16.4883,-3.6289 -24.7344,-5.46093 -2.75,-0.60938 -5.8281,-1.25 -6.0976,2.93359 -0.4063,6.39063 -4.7735,5.98047 -8.8203,4.94531 -6.0625,-1.55859 -11.8907,-0.55859 -17.8125,0.38672 -2.6094,0.41797 -4.9063,1.15625 -4.9063,4.34766 0,2.49609 1.5625,4.63281 3.7734,4.68359 11.711,0.28906 23.1993,8.50391 35.3086,-0.71484 7.2305,-5.50781 22.9024,0.58203 27.125,8.95312 0.4493,0.89063 0.9766,2.48828 0.5625,2.95703 -7.7226,8.67969 2.1993,6.80469 5.168,8.04688 6.6445,2.77344 14.4063,2.46484 21.6328,7.58203 -4.293,1.40625 -7.1719,-0.35937 -9.8633,-1.26172 -28.3437,-9.49609 -58.0937,-12.05469 -87.1601,-17.97265 -9.0586,-1.84375 -17.9219,-4.63282 -26.875,-6.99219 -2.8438,-0.75 -4.9649,-2.33594 -5.543,-5.34766 -0.7109,-3.73437 1.0586,-7.0664 4.1641,-8.10547 11.9101,-3.98437 18.2695,-14.0625 26.1679,-22.51953 1.7539,-1.8789 3.8008,-3.63281 2.4532,-6.29687 -5.8008,-11.4336 0.164,-20.85547 6.8281,-28.37891 11.7851,-13.30859 16.0234,-28.64453 17.0859,-45.59766 0.4571,-7.26562 1.4961,-14.26953 10.4883,-16.26953 1.2813,-0.28515 2.9492,-2.11718 3.1445,-3.42968 1.1993,-7.97266 6.9805,-9.95704 13.5508,-10.39844 10.8633,-0.72266 17.6719,-6.77735 21.5274,-16.22656 4.0937,-10.02735 11.4453,-16.32422 20.8789,-20.78125 1.7148,-0.8086 3.5078,-1.64063 4.9414,-2.85157 9.4492,-8 18.5429,-7.18359 26.0195,2.3125 4.3672,5.54297 10.1602,8.28516 17.2305,7.11328 5.7344,-0.94921 7.0742,1.82422 5.8242,6.45704 -1.1094,4.11328 -1.7383,7.92187 0.6211,11.78906 1.3125,2.14844 0.8516,4.16015 -1.1211,5.80078 -7.0117,5.83984 -6.1719,13.55469 -2.9648,20.22266 7.1953,14.96484 3.8593,28.75 -2.1875,42.83984 -1.8282,4.26953 -8.25,10.46094 2.7109,12.55078 1.8984,0.36328 1.3476,2.69141 1.1133,4.28516 -0.4727,3.23437 -1.086,6.44922 -1.4961,9.6914 -0.2735,2.14063 -0.543,4.33594 -0.3594,6.46875 0.2266,2.69532 2.2188,4.47657 4.5117,5.40625 8.3164,3.38282 9.7188,17.58203 22.6446,14.07032 3.3671,-0.91407 8.5507,-3.625 10.8671,1.76171 2.2774,5.29297 -0.7812,9.53907 -4.75,12.83985 -5.6796,4.71875 -9.0703,9.78906 -5.9961,17.66797 2.668,6.84375 7.4063,4.76953 12.1915,3.85547 5.4921,-1.05079 4.9531,-4.09766 3.6835,-8.45704 -3.1132,-10.6875 1.3711,-15.03515 11.9649,-13.7539 5.7773,0.69531 8.5234,2.62109 12.1797,7.46484 4.25,5.61719 3.2695,9.42188 1.6054,14.71094 -1.5156,4.82812 0.3282,8.23047 5.9297,7.98437 17.1719,-0.75781 22.8828,13.6211 31.5821,23.92579 2.2695,2.69531 -0.2539,3.60937 -2.7774,3.85937 -26.0312,2.59375 -51.9726,2.08594 -77.8125,-2.14062 -4.1406,-0.67579 -5.5703,-1.83985 -3.0547,-6.35938 3.1368,-5.64062 -1.1289,-9.01172 -5.8476,-10.18359 -4.8477,-1.20703 -10.9571,-3.84766 -13.6641,3.82422 -1.8437,5.22656 -12.8242,12.21484 -18.3672,11.64843 -5.8086,-0.58984 -8.2734,-3.60156 -4.7968,-8.71093 2.5664,-3.76954 1.8476,-6.23438 -0.629,-9.38282 -4.371,-5.57031 -8.1718,-11.61718 -13.5429,-16.32812 -3.6914,-3.23438 -7.8321,-7.39453 -12.6641,-2.51563 -4.539,4.58594 -0.3711,8.3711 2.5391,11.98047 1.6445,2.04297 4.3672,3.33985 4.7226,7.21094"
         style="fill:#009ce1;fill-opacity:1;fill-rule:nonzero;stroke:none" />
      <g
         id="g6400"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6384"
           y="746.75989"
           x="1059.345"
           xlink:href="#glyph3-28" />
        <use
           height="100%"
           width="100%"
           id="use6386"
           y="746.75989"
           x="1073.187"
           xlink:href="#glyph3-13" />
        <use
           height="100%"
           width="100%"
           id="use6388"
           y="746.75989"
           x="1082.097"
           xlink:href="#glyph3-3" />
        <use
           height="100%"
           width="100%"
           id="use6390"
           y="746.75989"
           x="1093.995"
           xlink:href="#glyph3-21" />
        <use
           height="100%"
           width="100%"
           id="use6392"
           y="746.75989"
           x="1098.837"
           xlink:href="#glyph3-3" />
        <use
           height="100%"
           width="100%"
           id="use6394"
           y="746.75989"
           x="1110.735"
           xlink:href="#glyph3-10" />
        <use
           height="100%"
           width="100%"
           id="use6396"
           y="746.75989"
           x="1118.007"
           xlink:href="#glyph3-7" />
        <use
           height="100%"
           width="100%"
           id="use6398"
           y="746.75989"
           x="1128.573"
           xlink:href="#glyph3-8" />
      </g>
    </g>
    <g
       id="SV03">
      <title
         id="title7269">SAN MIGUEL</title>
      <path
         inkscape:connector-curvature="0"
         id="path5970"
         d="m 1258.8867,650.55078 c 1.211,6.00391 4.2344,8.96094 10.9258,7.82031 4.5859,-0.78515 9.0703,1.57032 14.1914,0.19141 3.8984,-1.05078 7.5391,2.47656 6.7461,7.84766 -1.5391,10.41406 3.9922,16.11718 15.1992,14.87109 7.6094,-0.84766 15.1875,-1.22266 22.8203,-1.32813 4.5157,-0.0586 7.6407,1.78907 8.1016,6.25391 1.0312,9.99609 2.75,20.26953 -4.5352,28.9375 -2.8007,3.33203 -3.2031,6.71875 -1.6562,10.60938 1.3047,3.29296 2.2461,6.7539 3.7851,9.92578 4.2774,8.80859 4.6719,17.05859 -2.1601,24.94922 -3.4727,4.01562 -3.8789,8.28125 0.5703,12.20312 1.4453,1.27344 2.9688,3.13672 1.6445,4.99609 -6.5898,9.27344 -2.7929,20.17579 -4.7695,30.1875 -1.0703,5.42188 -2.6445,9.625 -6.6719,13.33985 -6.5664,6.0664 -13.1328,11.98828 -15.8633,21.28906 -1.7773,6.05078 -9.5273,6.95313 -13.7773,2.20703 -4.1719,-4.66406 -8.1172,-9.5625 -11.8125,-14.61328 -4.5078,-6.17187 -10.2656,-9.28906 -17.9687,-9.64453 -9.1485,-0.42188 -9.5586,-1.34375 -6.4532,-9.63281 3.125,-8.33203 -4.9531,-20.60157 -13.9687,-21.27344 -1.6211,-0.12109 -3.2539,-0.33594 -4.836,-0.69922 -8.6015,-1.96094 -14.6328,2.67188 -15.039,11.73047 -0.07,1.60547 0.2969,3.24609 0.5742,4.85547 0.6328,3.65234 -0.8945,5.8125 -4.4805,6.43359 -4.0039,0.69531 -5.2343,-2.0664 -5.9883,-5.16406 -0.8437,-3.46094 -0.027,-6.41016 2.7891,-8.80859 2.0625,-1.75782 4.3828,-3.46485 5.7813,-5.69922 2.7617,-4.40235 5.5195,-9.48828 2.832,-14.53516 -2.4844,-4.66016 -7.8594,-3.08984 -11.9688,-2.63672 -6.5117,0.71094 -12.6601,1.77344 -14.4414,-6.95312 -0.094,-0.45703 -0.6172,-1.03907 -1.0664,-1.1875 -13.0351,-4.36328 -9.6758,-14.6211 -8.7422,-24.0586 0.3633,-3.69922 1.4649,-7.30468 -4.2148,-8.90625 -4.293,-1.20703 -0.75,-4.58984 0.1523,-6.65234 4.9375,-11.3125 9.4258,-22.57422 5.7813,-35.34375 -0.8281,-2.90234 -1.8008,-5.62891 -3.0274,-8.375 -2.9609,-6.59375 -3.6523,-13.14453 1.9571,-18.91406 1.8437,-1.89453 3.1523,-4.28516 2.164,-6.64844 -2.2226,-5.3125 -1.2343,-10.71484 -1.3164,-16.11719 -0.09,-5.77344 -2.1484,-8.98437 -8.6523,-6.41406 -6.7578,2.66797 -11.2266,-1.41406 -14.4024,-6.25781 -4.0546,-6.17969 -9.0234,-8.64844 -16.3945,-8.22266 -6.4844,0.37891 -14.3711,1.83594 -15.3945,-8.46484 -0.062,-0.63672 -1.0235,-1.69141 -1.5664,-1.69141 -7.1446,-0.004 -9.4688,-3.82422 -9.0352,-10.48437 0.3516,-5.37891 0.8711,-10.17969 3.5352,-15.44532 4.4219,-8.75781 10.1914,-17.26953 11.1875,-27.54687 0.2969,-3.07031 1.9531,-7.66406 5.0078,-5.17578 6.5234,5.3125 11.7383,-0.61328 17.4961,-0.33203 0.9726,0.0508 2.5234,-0.40235 2.9023,-1.10938 7.2578,-13.49219 18.2149,-5.99219 27.9024,-4.83984 3.4648,0.41015 24.8593,-5.55469 26.9765,-8.51563 2.1133,-2.95312 4.3828,-5.44922 8.1602,-6.3164 9.4961,-2.1875 10.4453,-1.66797 12.9961,7.80859 0.5664,2.10547 0.9531,4.29687 1.8125,6.28125 3.4414,7.94141 2.6914,14.16406 -6.3633,17.66016 -4.0312,1.55468 -4.8633,4.35937 -3.0625,8.53515 3.3867,7.85547 7.2734,15.05078 14.3672,20.42578 7.6484,5.79297 6.3281,12.52735 -2.8633,15.4336 -5.7148,1.80859 -11.2383,3.46484 -11.8125,10.54687 -0.582,7.17969 1.3164,13.05469 7.918,17.51953 6.4883,4.38672 12.0937,10.08985 18.0859,15.21485 z m 0,0"
         style="fill:#009ce1;fill-opacity:1;fill-rule:nonzero;stroke:none" />
      <g
         id="g6422"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6402"
           y="715.54791"
           x="1207.665"
           xlink:href="#glyph3-9" />
        <use
           height="100%"
           width="100%"
           id="use6404"
           y="715.54791"
           x="1218.627"
           xlink:href="#glyph3-4" />
        <use
           height="100%"
           width="100%"
           id="use6406"
           y="715.54791"
           x="1229.193"
           xlink:href="#glyph3-8" />
        <use
           height="100%"
           width="100%"
           id="use6408"
           y="715.54791"
           x="1241.163"
           xlink:href="#glyph3-11" />
        <use
           height="100%"
           width="100%"
           id="use6410"
           y="715.54791"
           x="1245.771"
           xlink:href="#glyph3-29" />
        <use
           height="100%"
           width="100%"
           id="use6412"
           y="715.54791"
           x="1262.601"
           xlink:href="#glyph3-16" />
        <use
           height="100%"
           width="100%"
           id="use6414"
           y="715.54791"
           x="1267.443"
           xlink:href="#glyph3-22" />
        <use
           height="100%"
           width="100%"
           id="use6416"
           y="715.54791"
           x="1279.575"
           xlink:href="#glyph3-3" />
        <use
           height="100%"
           width="100%"
           id="use6418"
           y="715.54791"
           x="1291.473"
           xlink:href="#glyph3-14" />
        <use
           height="100%"
           width="100%"
           id="use6420"
           y="715.54791"
           x="1302.309"
           xlink:href="#glyph3-21" />
      </g>
    </g>
    <g
       id="SV12">
      <title
         id="title7283">MORAZAN</title>
      <path
         inkscape:connector-curvature="0"
         id="path5968"
         d="m 1258.9453,650.61719 c -3.7422,-8.24219 -10.5898,-13.83985 -17.4765,-19.03125 -5.293,-3.99219 -5.754,-8.78125 -5.336,-14.39453 0.4141,-5.5 5.0039,-5.62891 8.7539,-7.03907 4.1797,-1.57422 9.6485,-1.89843 10.418,-7.75781 0.75,-5.70312 -2.082,-10.04297 -6.668,-13.14453 -4.4258,-3 -7.5078,-6.77344 -9.5976,-11.81641 -2.9805,-7.19531 -3.8321,-13.02343 5.2304,-16.22656 3.7422,-1.32031 4.3086,-4.33984 3.211,-8.05469 -2.168,-7.32031 -4.293,-14.66406 -6.0117,-22.09765 -2.1993,-9.51953 0.1953,-12.38672 9.9531,-12.92969 3.4179,-0.19141 7.5664,0.88672 9.3203,-3.30469 1.6484,-3.94531 -2.1211,-5.70312 -4.1289,-8.09765 -2.1797,-2.59766 -4.1485,-5.61719 -2.7735,-8.91016 1.625,-3.89063 5.5313,-2.62891 8.6758,-2.36328 2.1563,0.1875 4.6172,0.32031 6.3438,1.41406 9.7187,6.14844 18.7187,2.54297 27.8672,-1.41016 3.4726,-1.5 7.0586,-2.89843 11.0703,-2.28125 5.8047,0.89454 9.75,2.57032 10.5859,9.85938 0.9453,8.25391 3.8438,15.97656 11.4688,21.62891 6.3398,4.69531 12.9648,10.0039 13.3007,19.55468 0.1485,4.20313 3.4532,5.46094 7.0313,2.66016 3.5195,-2.75781 7.6758,-4.07813 11.6289,-5.89453 3.2813,-1.50781 6.4414,-3.375 9.5703,0.27734 3.0625,3.57031 6.5977,7.28906 4.4141,12.31641 -2.3125,5.32031 -1.6406,10.03515 0.8554,14.85547 2.211,4.25781 0.6875,7.91015 -1.832,11.40234 -4.789,6.62891 -9.5859,13.25391 -14.375,19.88281 -2.9062,4.02344 -2.5195,6.58594 3.0703,6.58985 7.7657,0.0117 9.2969,4.48047 7.6211,10.88281 -2.4609,9.39844 -0.3125,20.28125 -9.164,27.71875 -1.3321,1.12109 -1.3204,4.04297 -1.6055,6.17578 -1.8867,14.09766 -14.7031,25.42969 -28.9258,25.83594 -8.7031,0.24609 -17.3906,1.30859 -26.0898,1.40625 -9.793,0.10937 -12.5157,-2.87891 -12.0508,-12.37891 0.2695,-5.47656 -1.9531,-10.08594 -7.2852,-9.79687 -5.9414,0.32812 -11.6015,-2.78907 -17.5312,-0.67578 -4.7891,1.70703 -6.2617,-3.52344 -9.5977,-4.91797 z m 0,0"
         style="fill:#009ce1;fill-opacity:1;fill-rule:nonzero;stroke:none" />
      <g
         id="g6430"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6424"
           y="578.78387"
           x="1258.749"
           xlink:href="#glyph3-29" />
        <use
           height="100%"
           width="100%"
           id="use6426"
           y="578.78387"
           x="1275.579"
           xlink:href="#glyph3-12" />
        <use
           height="100%"
           width="100%"
           id="use6428"
           y="578.78387"
           x="1286.829"
           xlink:href="#glyph3-18" />
      </g>
      <g
         id="g6440"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6432"
           y="578.78387"
           x="1293.885"
           xlink:href="#glyph3-4" />
        <use
           height="100%"
           width="100%"
           id="use6434"
           y="578.78387"
           x="1304.451"
           xlink:href="#glyph3-26" />
        <use
           height="100%"
           width="100%"
           id="use6436"
           y="578.78387"
           x="1313.667"
           xlink:href="#glyph3-7" />
        <use
           height="100%"
           width="100%"
           id="use6438"
           y="578.78387"
           x="1324.233"
           xlink:href="#glyph3-8" />
      </g>
    </g>
    <g
       id="SV07">
      <title
         id="title7301">LA UNION</title>
      <path
         inkscape:connector-curvature="0"
         id="path5966"
         d="m 1461.8008,608.90625 c -0.3008,1.70703 0,4.34375 -1.1563,5.85937 -9.0625,11.88672 -8.75,25.99219 -9.7539,39.76172 -0.3672,5.06641 -1.4453,9.53907 -5.1718,13.30469 -8.1485,8.22656 -7.0235,19.73438 -9.0782,29.76563 -1.3359,6.52343 6.0547,8.35937 12.2657,8.28906 9.5585,-0.11719 17.7929,9.78515 15.414,18.22656 -1.1601,4.10547 -3.5703,7.16016 -7.7539,7.34375 -6.9375,0.30469 -11.3281,4.50391 -15.9375,8.75391 -7.9375,7.3164 -15.4726,6.14843 -20.3906,-3.1875 -2.1836,-4.14453 -5.0664,-3.9961 -7.8711,-1.30469 -7.6367,7.31641 -11.9609,16.13672 -10.793,27.01562 1.1055,10.31641 7.4453,16.125 17.0196,18.45313 8.1484,1.98047 9.4296,11.67969 16.9335,14.31641 1.1602,0.40625 0.418,2.51562 -0.2773,3.71093 -4.3828,7.52735 -8.3242,15.39453 -16.5195,19.78907 -11.9961,6.4375 -24.086,12.63281 -37.1602,16.68359 -6.125,1.89844 -6.6719,4.57422 -1.9961,8.8125 0.8047,0.73047 1.7461,1.32812 2.461,2.13672 1.6211,1.8164 4.039,3.84765 3.1015,6.27344 -1.2461,3.22265 -4.6875,2.14062 -7.2422,1.8125 -17.2851,-2.21875 -34.5507,-4.59375 -51.8281,-6.89454 -2.4258,-0.32421 -4.8672,-0.59765 -7.3086,-0.75781 -8.9609,-0.58594 -10.4101,-3.17187 -5.9414,-11.125 2.9922,-5.32422 7.7656,-9.16015 12.2344,-13.07812 5.5781,-4.88672 7.7695,-10.49219 7.707,-17.91407 -0.078,-9.03515 -2.2539,-18.65625 4.8164,-26.59375 1.6485,-1.84765 0.6563,-4.49609 -1.039,-5.92187 -4.7266,-3.98047 -3.6563,-8.15234 -0.5547,-12.14844 5.5078,-7.08984 5.4492,-14.41406 2.0078,-22.27734 -1.7422,-3.98438 -2.9727,-8.19531 -4.4453,-12.29688 -1.0664,-2.97265 -1.5157,-6.13281 0.789,-8.51562 8.2891,-8.5625 6.9727,-19.19922 5.9297,-29.3711 -0.5547,-5.42968 0.4805,-8.54687 4.9766,-11.5 9.293,-6.10156 17.5937,-13.13281 17.4101,-25.78906 -0.012,-1.02734 0.336,-2.42578 1.043,-3.03906 9.5899,-8.33984 7.6328,-20.51953 10.5039,-31.08594 1.711,-6.29297 -0.02,-11.1289 -6.4648,-12.80078 -6.0352,-1.5625 -4.336,-4.03516 -1.8086,-7.28906 2.1719,-2.79688 4.0859,-5.80078 6.3164,-8.54297 6.1133,-7.51172 10.8242,-15.16406 5.1484,-25.16797 -1.2265,-2.15625 -0.4336,-4.77734 0.6172,-7.11328 0.6602,-1.47656 1.1328,-3.04688 1.5625,-4.60547 1.082,-3.89453 -4.375,-9.89453 -2.4336,-9.80078 7.668,0.38281 13.875,-5.28516 21.2578,-4.08594 7.4727,1.21485 14.3985,0.71485 21.4492,-2.64453 6.3008,-3.00391 12.8516,-3.46484 16.1524,5 0.3789,0.97266 1.1133,2.15234 1.9883,2.53125 14.8242,6.38672 18.7226,22.875 30.0976,32.42969 3.3594,2.82031 3.9336,6.25781 2.1719,10.28906 -1.8477,4.24219 -3.1484,8.73828 -6.0039,12.48438 -2.5742,3.38281 -4.4727,6.91015 -2.4453,11.80859"
         style="fill:#009ce1;fill-opacity:1;fill-rule:nonzero;stroke:none" />
      <g
         id="g6446"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6442"
           y="707.96991"
           x="1346.463"
           xlink:href="#glyph3-15" />
        <use
           height="100%"
           width="100%"
           id="use6444"
           y="707.96991"
           x="1356.975"
           xlink:href="#glyph3-4" />
      </g>
      <g
         id="g6454"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6452"
           y="707.96991"
           x="1372.149"
           xlink:href="#glyph3-28" />
      </g>
      <g
         id="g6458"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6456"
           y="707.96991"
           x="1385.991"
           xlink:href="#glyph3-8" />
      </g>
      <g
         id="g6462"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6460"
           y="707.96991"
           x="1397.9611"
           xlink:href="#glyph3-16" />
      </g>
      <g
         id="g6466"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6464"
           y="707.96991"
           x="1402.803"
           xlink:href="#glyph3-30" />
      </g>
      <g
         id="g6470"
         style="fill:#fafafa;fill-opacity:1">
        <use
           height="100%"
           width="100%"
           id="use6468"
           y="707.96991"
           x="1414.053"
           xlink:href="#glyph3-8" />
      </g>
    </g>
  </g>
</svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import router from "@/router";

export default defineComponent({
  name: "MapaSv",
  data() {
    return {};
  },
  mounted() {
     if ((this as any).nextRoute == '') return;
     const t = document.querySelectorAll('.mapaSV > g > g');
     for (let n = 0; n != t.length; n++) {
        t[n].classList.add('hoverable');
        t[n].addEventListener('click', (e) => {
           const i = (e as any).currentTarget.id;
           router.replace((this as any).nextRoute + i);
        })
     }
  },
  props: {
    nextRoute: {
      type: String,
      default: ""
    }
  }  
  
});
</script>

<style scoped>
.mapaSV { width: 100%; height: auto; padding: 15px 0;}
.mapaSV g > g.hoverable:hover {
   filter: brightness(130%);
   cursor: pointer;
}

</style>